/* globals Raven */
/* eslint moduleName:0 */

"use strict";

(function () {
  var itsoftApp;
  var pageHeader = document.querySelector(".page-header");
  var pageHeaderContent = pageHeader.querySelector(".page-header__content");
  var disclaimer = document.querySelector(".disclaimer");
  var cookie = document.querySelector(".js-cookies");
  var slice = [].slice;
  var noScript = document.querySelector("[data-no-script]");
  if (noScript) {
    noScript.removeAttribute("data-no-script");
  }
  var hash = location.hash;
  var hashElement = hash ? document.querySelector(hash) : null;
  window.itsoftApp = itsoftApp = {
    createNS: function createNS(namespace) {
      var i, len, nsparts, parent, part;
      nsparts = namespace.split(".");
      parent = itsoftApp;

      // we want to be able to include or exclude the root namespace so we strip
      // it if it's in the namespace
      if (nsparts[0] === "itsoftApp") {
        nsparts = nsparts.slice(1);
      }

      // loop through the parts and create a nested namespace if necessary
      for (i = 0, len = nsparts.length; i < len; i++) {
        part = nsparts[i];

        // check if the current parent already has the namespace declared
        // if it isn't, then create it
        if (typeof parent[part] === "undefined") {
          parent[part] = {};
        }

        // get a reference to the deepest element in the hierarchy so far
        parent = parent[part];
      }
      return parent;
    },
    state: {
      hash: hash,
      hashElement: hashElement,
      hashActive: hash && hashElement,
      сheckListElementsToBeUpdatedDuringResizing: {
        "headerHeight": false,
        "disclaimerHeight": false,
        "viewWidth": false,
        "viewHeight": false,
        "cookieHeight": false,
        "footerTopCoordRelToDocument": false
      }
    },
    calculations: {
      headerHeight: null,
      headerStaticHeight: null,
      headerFixedHeight: null,
      viewWidth: null,
      viewHeight: null,
      cookieHeight: null,
      disclaimerHeight: null,
      footerTopCoordRelToDocument: null
    },
    isLocal: !!document.getElementById("js-server-local"),
    libraries: {
      gsap: {
        name: "gsap",
        queue: [],
        started: false,
        loaded: false,
        script: "/assets/scripts/gsap/gsap.min.js",
        cb: function cb() {
          DEBUG && console.log("GSAP");
        }
      },
      scrollTrigger: {
        name: "scrollTrigger",
        queue: [],
        started: false,
        loaded: false,
        dependency: "gsap",
        script: "/assets/scripts/gsap/ScrollTrigger.min.js",
        cb: function cb() {
          gsap.registerPlugin(ScrollTrigger);
        }
      },
      scrollToPlugin: {
        name: "scrollTo",
        active: null,
        queue: [],
        started: false,
        loaded: false,
        dependency: "gsap",
        script: "/assets/scripts/gsap/ScrollToPlugin.min.js",
        cb: function cb() {
          gsap.registerPlugin(ScrollToPlugin);
        }
      },
      smoothScroll: {
        name: "smoothScroll",
        queue: [],
        started: false,
        loaded: false,
        script: "/assets/scripts/smoothScroll/smooth-scroll.min.js"
      },
      slider: {
        name: "swiper",
        queue: [],
        started: false,
        loaded: false,
        style: "/assets/scripts/swiper/swiper.min.css",
        script: "/assets/scripts/swiper/swiper.min.js",
        cb: function cb() {
          Swiper.initedSliders = {};
        }
      }
    },
    utils: {
      debouncer: function debouncer(func, timeout) {
        var timeoutID;
        if (timeout == null) {
          timeout = 200;
        }
        timeoutID = undefined;
        return function () {
          var args, scope;
          scope = this;
          args = arguments;
          clearTimeout(timeoutID);
          timeoutID = setTimeout(function () {
            func.apply(scope, Array.prototype.slice.call(args));
          }, timeout);
        };
      },
      throttler: function throttler(func, ms) {
        var isThrottled = false,
          savedArgs,
          savedThis;
        function wrapper() {
          if (isThrottled) {
            // (2)
            savedArgs = arguments;
            savedThis = this;
            return;
          }
          func.apply(this, arguments); // (1)

          isThrottled = true;
          setTimeout(function () {
            isThrottled = false; // (3)
            if (savedArgs) {
              wrapper.apply(savedThis, savedArgs);
              savedArgs = savedThis = null;
            }
          }, ms);
        }
        return wrapper;
      },
      // Stealed from
      // https://github.com/VodkaBears/Remodal
      getScrollbarWidth: function getScrollbarWidth() {
        return window.innerWidth - document.documentElement.clientWidth;
      },
      // TODO
      // REPAINT
      // Вызывает Recalculate Style
      // Проверить, из-за чего, и можно ли избавиться
      getScrTop: function getScrTop() {
        var $body, $document, $wrapper, scrTop;
        $document = itsoftApp.commonVars.$document;
        $body = itsoftApp.commonVars.$body;
        $wrapper = itsoftApp.commonVars.$wrapper;
        scrTop = Math.max($document.scrollTop, $body.scrollTop, $wrapper.scrollTop, 0); //pageYOffset
        // console.log($document.scrollTop(), $body.scrollTop(), $wrapper.scrollTop())
        return scrTop;
      },
      getTime: function () {
        var res;
        if (window.performance && typeof window.performance.now === "function") {
          res = function res(precision) {
            if (precision == null) {
              precision = 1;
            }
            return parseFloat(window.performance.now().toFixed(precision));
          };
        } else {
          res = function res(precision) {
            if (precision == null) {
              precision = 1;
            }
            return parseFloat(new Date().getTime().toFixed(precision));
          };
        }
        return res;
      }(),
      newMeasureFunc: function newMeasureFunc(precision) {
        var res, t0;
        if (precision == null) {
          precision = 2;
        }
        t0 = itsoftApp.utils.getTime(precision);
        res = function res() {
          var t1, t2;
          t1 = itsoftApp.utils.getTime(precision);
          t2 = parseFloat((t1 - t0).toFixed(precision));
          t0 = t1;
          return t2;
        };
        return res;
      },
      getInitTimes: function getInitTimes() {
        var k, module, obj, ref, total;
        obj = {};
        total = 0;
        ref = itsoftApp.modules;
        for (k in ref) {
          module = ref[k];
          if (module.initialized && module.__mName__ !== undefined) {
            obj[module.__mName__] = module.__initTime__;
            total += module.__initTime__;
          }
        }
        obj.all = Math.round(total);
        return obj;
      },
      checkIsSafari: function checkIsSafari() {
        var UA = navigator.userAgent.toLowerCase();
        if (UA.indexOf("safari") != -1) {
          if (UA.indexOf("chrome") > -1) {
            return;
          } else {
            return true;
          }
        }
      },
      getViewportSize: function getViewportSize() {
        if (itsoftApp.utils.checkIsSafari()) {
          itsoftApp.calculations.viewWidth = document.documentElement.clientWidth;
        } else {
          itsoftApp.calculations.viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        }
        DEBUG && console.log(itsoftApp.calculations.viewWidth, "VIEWPORT");
        return itsoftApp.calculations.viewWidth;
      },
      getViewportHeight: function getViewportHeight() {
        itsoftApp.calculations.viewHeight = document.documentElement.clientHeight;
        // DEBUG && console.log(itsoftApp.calculations.viewHeight, "VIEWHEIGHT")
        return itsoftApp.calculations.viewHeight;
      },
      getHeaderFixedHeight: function getHeaderFixedHeight() {
        if (pageHeader.classList.contains("js-fixed")) {
          DEBUG && console.log("FIXED");
          itsoftApp.calculations.headerFixedHeight = itsoftApp.calculations.headerHeight;
        } else {
          var headerClone = pageHeader.cloneNode(true);
          var _pageHeaderContent = headerClone.querySelector(".page-header__content");
          headerClone.style.visibility = "hidden";
          headerClone.style.pointerEvents = "none";
          if (_pageHeaderContent) {
            _pageHeaderContent.style.transition = "none";
          }
          headerClone.classList.add("js-fixed");
          document.body.appendChild(headerClone);
          itsoftApp.calculations.headerFixedHeight = headerClone.offsetHeight;
          headerClone.remove();
        }
      },
      getHeaderStaticHeight: function getHeaderStaticHeight() {
        if (!pageHeader.classList.contains("js-fixed")) {
          DEBUG && console.log("STATIC");
          itsoftApp.calculations.headerStaticHeight = itsoftApp.calculations.headerHeight;
        } else {
          if (pageHeaderContent) {
            pageHeaderContent.style.transition = "none";
          }
          pageHeader.classList.remove("js-fixed");
          itsoftApp.calculations.headerStaticHeight = pageHeader.offsetHeight;
          pageHeader.classList.add("js-fixed");
          if (pageHeaderContent) {
            pageHeaderContent.style.transition = "";
          }
        }
      },
      getHeaderHeight: function getHeaderHeight() {
        itsoftApp.calculations.headerHeight = pageHeader.offsetHeight;
        DEBUG && console.log(itsoftApp.calculations.headerHeight, "HEADERHEIGHT");
        return itsoftApp.calculations.headerHeight;
      },
      getCookieHeight: function getCookieHeight() {
        itsoftApp.calculations.cookieHeight = cookie && cookie.offsetHeight;
        DEBUG && console.log(itsoftApp.calculations.cookieHeight, "cookieHeight");
        return itsoftApp.calculations.cookieHeight;
      },
      getDisclaimerHeight: function getDisclaimerHeight() {
        itsoftApp.calculations.disclaimerHeight = disclaimer && disclaimer.offsetHeight;
        DEBUG && console.log(itsoftApp.calculations.disclaimerHeight, "disclaimerHeight");
        return itsoftApp.calculations.disclaimerHeight;
      },
      getCoordsRelPage: function getCoordsRelPage(el) {
        var box = el.getBoundingClientRect();
        return {
          top: box.top + pageYOffset,
          left: box.left + pageXOffset
        };
      },
      supportWebP: function supportWebP(callback) {
        var webP = new Image();
        webP.onload = function () {
          callback(webP.height === 1);
        };
        webP.onerror = function () {
          callback(false);
        };
        // Использование маленькой и прозрачной картинки WebP для проверки
        webP.src = 'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMw' + 'AgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
      }
    },
    loadScript: function loadScript(url, callback, error) {
      var script;
      script = document.createElement("script");

      // If "fallback" url passed as second argument
      var args = Array.prototype.slice.call(arguments);
      if (typeof callback === "string") {
        var fallbackUrl = callback;
        callback = error;
        var errorOri = args[3];
        error = function error() {
          DEBUG && console.log("%c[common] error while loading script: " + url + ". trying to load a fallback url: " + fallbackUrl, "color: red");
          itsoftApp.loadScript(fallbackUrl, callback, errorOri);
          if (!DEBUG && typeof Raven !== "undefined") {
            Raven.captureMessage("[common] error while loading script", {
              level: "warning",
              // one of 'info', 'warning', or 'error'
              extra: {
                "script": url,
                "fallback": fallbackUrl
              }
            });
          }
        };
      }
      var cb = function cb() {
        DEBUG && console.log("%c--[common] finished loading script: " + url, "color: #999");
        if (typeof callback === "function") {
          callback();
        }
      };

      // IE
      if (script.readyState) {
        script.onreadystatechange = function () {
          if (script.readyState === "loaded" || script.readyState === "complete") {
            script.onreadystatechange = null;
            cb();
          }
        };

        // Normal browsers
      } else {
        if (typeof error === "function") {
          script.onerror = error;
        }
        script.onload = cb;
      }
      script.src = url;
      document.getElementsByTagName("body")[0].appendChild(script);
      DEBUG && console.log("%c--[common] starting to load script: " + url, "color: #999");
    },
    loadStyle: function loadStyle(url) {
      var first, head, link;
      link = document.createElement("link");
      link.href = url;
      link.rel = "stylesheet";
      link.type = "text/css";
      head = document.getElementsByTagName("head")[0];
      first = head.firstChild;

      // Prepend styles in 'head' section
      head.insertBefore(link, first);
    },
    features: {
      // From Modernizr
      transitionEventEnd: function () {
        var el, t, transitions;
        el = document.createElement("fakeelement");
        transitions = {
          "transition": "transitionend",
          "OTransition": "oTransitionEnd",
          "MozTransition": "transitionend",
          "WebkitTransition": "webkitTransitionEnd"
        };
        for (t in transitions) {
          if (el.style[t] !== undefined) {
            el = null;
            return transitions[t];
          }
        }
        return false;
      }()
    },
    modules: {},
    initializedModules: [],
    createModule: function createModule() {
      var dep, dependencies, i, initFunc, j, len, mName, module, options, ref;
      mName = arguments[0], options = 3 <= arguments.length ? slice.call(arguments, 1, i = arguments.length - 1) : (i = 1, []), initFunc = arguments[i++];
      if (typeof initFunc !== "function") {
        throw "Missing an initialization function for module '" + mName + "'";
      }

      // Create a namespace
      module = itsoftApp.createNS("modules." + mName);
      module.__mName__ = mName;
      module.initialized = false;

      // Set dependencies
      if (options.length && options[0].length) {
        dependencies = [];
        ref = options[0];
        for (j = 0, len = ref.length; j < len; j++) {
          dep = ref[j];
          if (typeof dep === "string" && dependencies.indexOf(dep) < 0 && dep !== mName) {
            dependencies.push(dep);
          }
        }
        if (dependencies.length) {
          module.dependencies = dependencies;
        }
      }

      // Set initialization function and behavior
      module.init = function () {
        var depModule, e, initTime, initializedModules, l, len1, t1, t2;
        try {
          if (module.dependencies) {
            for (l = 0, len1 = dependencies.length; l < len1; l++) {
              dep = dependencies[l];
              depModule = itsoftApp.modules[dep];
              if (!depModule) {
                DEBUG && console.log("%c[modules] missed module " + dep + " as a dependency for module " + mName + ". (it's ok only if module is not required for this page)", "color: #BB6565; font-style: italic");
                return false;
              }
              if (depModule.initialized) {
                continue;
              }
              depModule.init();
              if (!depModule.initialized) {
                DEBUG && console.log("%c[modules] can't init module " + dep + " as a dependency for module " + mName + ". (it's ok only if module is not required for this page)", "color: #BB6565; font-style: italic");
                return false;
              }
            }
          }
          t1 = itsoftApp.utils.getTime();
          if (initFunc.call(module) !== false) {
            t2 = itsoftApp.utils.getTime();
            initTime = parseFloat((t2 - t1).toFixed(1));
            module.__initTime__ = initTime;
            DEBUG && console.log("[module " + mName + "] module initialized in " + initTime + " ms");
            module.initialized = true;
            initializedModules = itsoftApp.initializedModules || [];
            initializedModules.push(mName);
            itsoftApp.initializedModules = initializedModules;
          }
        } catch (error1) {
          e = error1;
          if (typeof Raven !== "undefined") {
            Raven.captureException(e);
          }
          itsoftApp.errorHandler(e, {
            moduleName: mName
          });
        }
      };
      return module;
    },
    errorHandler: function errorHandler(error, options) {
      var pre;
      pre = "[error]";
      if (options && options.moduleName) {
        pre += "[module " + options.moduleName + "]";
      }
      if (console && console.error) {
        console.error(pre + "\n" + error + "\nNavigator: " + window.navigator.userAgent);
      }
    }
  };

  // Unit-tests for itsoftApp object
  if (DEBUG && typeof mocha !== "undefined" && typeof describe === "function") {
    mocha.setup("bdd");
    describe("itsoftApp object tests", function () {
      it("Should be an object", function () {
        expect(itsoftApp).to.be.an("object");
      });
      it("Should contain a loadScript function", function () {
        expect(itsoftApp.loadScript).to.be.a("function");
      });
      it("Should contain a loadStyle function", function () {
        expect(itsoftApp.loadStyle).to.be.a("function");
      });
      it("We can create a deep namespace scope with a string like 'ns1.ns2.ns3'", function () {
        itsoftApp.createNS("ns1.ns2.ns3");
        expect(itsoftApp.ns1).to.be.an("object");
        expect(itsoftApp.ns1.ns2).to.be.an("object");
        expect(itsoftApp.ns1.ns2.ns3).to.be.an("object");
        delete itsoftApp.ns1;
      });
      it("initializedModules must be defined from the start", function () {
        expect(itsoftApp.initializedModules).to.be.an("array");
      });
      describe(".modules", function () {
        it("Should be a function to create modules", function () {
          expect(itsoftApp.createModule).to.be.a("function");
        });
        it("We can simply create a single module", function () {
          var module, testFunc;
          testFunc = function testFunc() {
            console.log("test module init");
          };
          var mName = "testmodule" + Math.round(Math.random() * 100);
          module = itsoftApp.createModule(mName, testFunc);
          expect(module).to.be.equal(itsoftApp.modules[mName]);
          itsoftApp.initializedModules.splice(itsoftApp.initializedModules.indexOf(mName), 1);
          delete itsoftApp.modules[mName];
        });
        it("We can't create a module without initialization function", function () {
          var module;
          module = function module() {
            itsoftApp.createModule("testmodule");
          };
          expect(module).to["throw"];
        });
        it("Each module must have an init function", function () {
          var module;
          for (module in itsoftApp.modules) {
            expect(itsoftApp.modules[module].init).to.be.a("function");
          }
        });
        it("Should throw an exception if we try to initialize a module twice", function () {
          var mName, module, testFunc;
          mName = "testmodule" + Math.round(Math.random() * 100);
          testFunc = function testFunc() {
            return 1;
          };
          module = itsoftApp.createModule(mName, testFunc);
          module.init();
          expect(module.init).to["throw"];
          itsoftApp.initializedModules.splice(itsoftApp.initializedModules.indexOf(mName), 1);
          delete itsoftApp.modules[mName];
        });
      });
    });
  }
  var itsoftAppInitFunc = function itsoftAppInitFunc() {
    var init = function init() {
      itsoftApp.commonVars = {
        dimensionsAndCoordsFlag: true,
        // отключить, если не нужно получать размеры и координаты страницы/окна в модули pageLoad и pageResize
        $document: document.documentElement,
        $body: document.body,
        $window: window,
        $wrapper: document.querySelector(".l-wrapper"),
        headerHeight: undefined,
        viewWidth: undefined
      };
      var benchmarkCloseBtn, benchmarkDiv, criticalInitTime, dColor, fTime, initTimes, m, module, moduleName, t, time, warningModules;
      if (DEBUG) {
        t = itsoftApp.utils.getTime();
      }
      itsoftApp.ajaxDisabled = false; //нужно для работы с аяксовыми переходами.

      itsoftApp.removeAllModules = function () {
        for (m in itsoftApp.modules) {
          module = itsoftApp.modules[m];
          module.initialized = false;
        }
        itsoftApp.initializedModules = [];
        DEBUG && console.log("%c[common] all modules removed", "font-weight: bold;");
      };
      itsoftApp.initAllModules = function () {
        // Initialize itsoftApp modules
        itsoftApp.removeAllModules();
        for (m in itsoftApp.modules) {
          module = itsoftApp.modules[m];
          if (!module.initialized && typeof module.init === "function") {
            module.init();
          }
        }
      };
      itsoftApp.initAllModules();
      if (DEBUG) {
        fTime = Math.round(itsoftApp.utils.getTime() - t);
        dColor = fTime < 200 ? "green" : "red";
        console.log("%c[common] document ready event fired, " + itsoftApp.initializedModules.length + " modules initialized in " + fTime + " ms: " + function () {
          var i, len, ref, results;
          ref = itsoftApp.initializedModules;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            m = ref[i];
            results.push(" " + m + "(" + itsoftApp.modules[m].__initTime__ + "ms)");
          }
          return results;
        }(), "color: " + dColor);
      }

      // Add benchmark div
      benchmarkDiv = document.getElementById("benchmark");
      if (typeof itsoftApp.utils.getInitTimes === "function" && (DEBUG || window.location.hash === "#benchmark") && !benchmarkDiv) {
        benchmarkDiv = document.createElement("div");
        benchmarkDiv.className = "benchmark";
        benchmarkDiv.id = "benchmark";
        if (typeof itsoftApp.utils.getInitTimes === "function") {
          benchmarkDiv.innerHTML = "<small style=\"opacity: 0.7\">modules (ms):" + function () {
            var ref, results;
            ref = itsoftApp.utils.getInitTimes();
            results = [];
            for (m in ref) {
              t = ref[m];
              results.push(" " + m + ": " + t);
            }
            return results;
          }() + "</small>";
        }

        // Add close button
        benchmarkCloseBtn = document.createElement("a");
        benchmarkCloseBtn.onclick = function () {
          benchmarkDiv.parentNode.removeChild(benchmarkDiv);
        };
        benchmarkCloseBtn.innerHTML = "X";
        benchmarkCloseBtn.className = "benchmark__close";
        benchmarkDiv.appendChild(benchmarkCloseBtn);
        // document.body.appendChild(benchmarkDiv);
      }

      // Check for "too complex" modules
      // WARNING иногда такие "ошибки" возникают спонтанно
      // (например, все модули инициализируются за 0-2 мс, а один "выстрелил" на 300 мс).
      // Если это станет мешать проектам, то можно данные предупреждения
      // из логгера убрать.
      if (!DEBUG && typeof Raven !== "undefined") {
        initTimes = itsoftApp.utils.getInitTimes();
        warningModules = [];
        criticalInitTime = 50;
        for (moduleName in initTimes) {
          time = initTimes[moduleName];
          if (moduleName === "all") {
            continue;
          }
          if (time > criticalInitTime) {
            warningModules.push(moduleName);
          }
        }

        //  CHANGED: Вот именно из-за того, что один из модулей может
        //  случайно инициализироваться за какое-то неадекватно большое для него время.
        //  if warningModules.length > 0
        if (warningModules.length > 1) {
          Raven.captureMessage("[common] detected some \"long\" (initTime > " + criticalInitTime + " ms) modules", {
            level: "warning",
            // one of 'info', 'warning', or 'error'
            extra: initTimes
          });
        }
      }

      // If unit tests library loaded, just load a file with tests
      if (typeof mocha !== "undefined") {
        mocha.setup("bdd");
        mocha.run();
      }
    };
    if ("addEventListener" in document) {
      init();
    }
  };

  // Document ready event
  if ("addEventListener" in document) {
    document.addEventListener("DOMContentLoaded", itsoftAppInitFunc, false);

    // .. IE <= 8
  } else if ("attachEvent" in document) {
    document.attachEvent("onreadystatechange", function () {
      if (document.readyState === "complete") {
        itsoftAppInitFunc();
      }
    });
  }
})();
"use strict";

itsoftApp.createModule("accordion", function () {
  var module = this;
  var AccordionItem = function AccordionItem(accordionItemElement, ACCORDION) {
    this.ACCORDION = ACCORDION;
    this.state = {
      opened: accordionItemElement.classList.contains("js-accordion-item--active")
    };
    accordionItemElement.accordionItem = this;
    this.accordionItemElement = accordionItemElement;
    this.accordionHeadElement = accordionItemElement.querySelector(".js-accordion-head");
    this.accordionContentElement = accordionItemElement.querySelector(".js-accordion-content");
    this.accordionText = accordionItemElement.querySelector(".js-accordion-text");
    this.preventNone = this.accordionHeadElement.hasAttribute("data-prevent-none");
    this.once = this.accordionHeadElement.hasAttribute("data-once");
    this.init();
  };
  AccordionItem.prototype.init = function () {
    var ACCORDION_ITEM = this;
    this.openListener = ACCORDION_ITEM.onOpenTransitionEnd.bind(ACCORDION_ITEM);
    this.closeListener = ACCORDION_ITEM.onCloseTransitionEnd.bind(ACCORDION_ITEM);
    this.accordionHeadElement.addEventListener("click", ACCORDION_ITEM.onAccordionClick.bind(ACCORDION_ITEM));
  };
  AccordionItem.prototype.onAccordionClick = function (evt) {
    if (!this.preventNone) {
      /* если специально не указан атрибут data-prevent-none, отменяем действие по умолчанию, например, переход по ссылке */
      evt.preventDefault();
    }

    /* если элемент аккордеона уже активен, скрываем его... */
    if (this.state.opened && this.ACCORDION.currentClosedItem == false) {
      if (this.ACCORDION.leastOne) {
        return;
      }
      this.ACCORDION.currentClosedItem = this.ACCORDION.activeItem;
      this.ACCORDION.activeItems.splice(this.ACCORDION.activeItems.indexOf(this.ACCORDION.activeItem), 1);
      this.ACCORDION.activeItem = "";
      this.closeAccordion();

      // if (this.ACCORDION.accordionType !== "any" && this.ACCORDION.activeItems.length === 0) {
      if (this.ACCORDION.activeItems.length === 0) {
        this.ACCORDION.state.opened = false;
        this.ACCORDION.accordion.classList.remove("js-accordion--active");
      }

      /* ...иначе показываем */
    } else {
      /* если одновременно может быть раскрыт только один элемент, то есть нет атрибута data-type со значением any... */
      if (this.ACCORDION.accordionType !== "any") {
        /*...находим ранее активный элемент и скрываем его */

        if (this.ACCORDION.activeItem && this.ACCORDION.currentClosedItem == false) {
          this.ACCORDION.currentClosedItem = this.ACCORDION.activeItem;
          this.ACCORDION.activeItems.splice(this.ACCORDION.activeItems.indexOf(this.ACCORDION.activeItem), 1);
          this.ACCORDION.activeItem = "";
          this.ACCORDION.currentClosedItem.closeAccordion(); // Закрываем не текущий, а ранее активный элемент аккордеона
        }
      }

      /* показываем элемент, по которому был осуществлён клик */
      if (this.ACCORDION.currentOpenedItem == false) {
        this.ACCORDION.currentOpenedItem = this;
        this.openAccordion();
        if (!this.ACCORDION.state) {
          this.ACCORDION.state.opened = true;
          this.ACCORDION.accordion.classList.add("js-accordion--active");
        }
        if (this.ACCORDION.activeItems.length === this.ACCORDION.allItems.length && !this.ACCORDION.state.openedAll) {
          this.ACCORDION.state.openedAll = true;
        } else if (this.ACCORDION.activeItems.length < this.ACCORDION.allItems.length && this.ACCORDION.state.openedAll) {
          this.ACCORDION.state.openedAll = false;
        }
      }
    }

    /* если есть атрибут data-once, то клик по элементу аккордеона отлавливается только один раз, то есть его нельзя закрыть */
    if (this.once) {
      this.accordionHeadElement.removeEventListener("click", this.onAccordionClick.bind(this));
    }
  };
  AccordionItem.prototype.closeAccordion = function () {
    var ACCORDION_ITEM = this;
    var closedText = this.accordionItemElement.getAttribute("data-closed-text"); // todo: Проверить работу
    var height = this.accordionContentElement.clientHeight + "px";
    this.accordionItemElement.classList.add("js-accordion-item--close-ready");
    this.accordionContentElement.style.height = height;
    if (closedText) {
      this.accordionText.textContent = closedText; // TODO: Проверить работу
    }

    if (getComputedStyle(this.accordionContentElement).transition) {
      // TODO: доработать, так как отрицательно влияет на рендеринг
      this.accordionContentElement.addEventListener("transitionend", this.closeListener);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          ACCORDION_ITEM.accordionContentElement.style.height = "0px";
        });
      });
    } else {
      ACCORDION_ITEM.accordionContentElement.style.height = "0px";
      this.onCloseTransitionEnd();
    }
  };
  AccordionItem.prototype.onCloseTransitionEnd = function () {
    // стили находятся в файле /assets/styles/page.styl
    this.accordionItemElement.classList.remove("js-accordion-item--active");
    this.accordionItemElement.classList.remove("js-accordion-item--close-ready");
    this.accordionContentElement.removeEventListener("transitionend", this.closeListener);

    // if (this.ACCORDION.accordionType !== "any") {
    this.ACCORDION.currentClosedItem = "";
    // }

    if (this.ACCORDION.heightUpdateFlag) {
      window.gsap && itsoftApp.libraries.scrollTrigger.loaded && ScrollTrigger.refresh();
    }
    this.state.opened = false;
  };
  AccordionItem.prototype.openAccordion = function () {
    var ACCORDION = this;
    var openedText = this.accordionItemElement.getAttribute("data-opened-text"); //todo: проверить

    /* если есть атрибут со значением, заменяем название элемента аакордеона во время открытия */
    if (openedText) {
      this.accordionText.textContent = openedText; // todo: проверить
    }

    this.accordionItemElement.classList.add("js-accordion-item--open-ready");
    this.accordionContentElement.style.height = "auto";
    var height = this.accordionContentElement.clientHeight + "px";
    this.accordionContentElement.style.height = "0px";
    if (getComputedStyle(this.accordionContentElement).transition) {
      // TODO: доработать, так как отрицательно влияет на рендеринг
      this.accordionContentElement.addEventListener("transitionend", this.openListener);

      /* чтобы была анимация открытия */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          ACCORDION.accordionContentElement.style.height = height;
        });
      });
    } else {
      ACCORDION.accordionContentElement.style.height = height;
      this.onOpenTransitionEnd();
    }
  };
  AccordionItem.prototype.onOpenTransitionEnd = function () {
    // стили находятся в файле /assets/styles/page.styl
    /* если одноврменно может быть показан только один элемент аккордеона, то добавляем другую анимацию,
    //     чтобы раскрытый аккордеон не ушел за пределы экрана из-за прокрутки страницы */
    this.accordionItemElement.classList.remove("js-accordion-item--open-ready");
    this.accordionItemElement.classList.add("js-accordion-item--active");
    this.accordionContentElement.removeEventListener("transitionend", this.openListener);

    // if (this.ACCORDION.accordionType !== "any") {
    this.ACCORDION.activeItem = this;
    this.ACCORDION.activeItems.push(this);
    this.ACCORDION.currentOpenedItem = "";
    // }

    if (this.ACCORDION.heightUpdateFlag) {
      window.gsap && itsoftApp.libraries.scrollTrigger.loaded && ScrollTrigger.refresh();
    }
    this.state.opened = true;
  };
  var Accordion = function Accordion(accordion) {
    this.state = {
      opened: false,
      openedAll: false
    }, this.accordion = accordion;
    this.accordionType = accordion.getAttribute("data-type");
    this.leastOne = accordion.hasAttribute("data-least-one");
    this.accordionItemElements = accordion.querySelectorAll(".js-accordion-item");
    this.accordionHeadElements = accordion.querySelectorAll(".js-accordion-head");
    this.allItems = [];
    this.activeItems = [];
    this.activeItem = "";
    this.activeAccordionContent = "";
    this.currentItem = "";
    this.currentOpenedItem = "";
    this.currentClosedItem = "";
    this.currentOpenedContent = "";
    this.currentClosedContent = "";
    this.heightUpdateFlag = accordion.hasAttribute("data-height-update");
    this.init();
  };
  Accordion.prototype.init = function () {
    /* Добавляет каждому элементу аккордеона обработчик события клика */
    var ACCORDION = this;
    Array.from(ACCORDION.accordionItemElements).forEach(function (el) {
      var accordionItem = new AccordionItem(el, ACCORDION);
      ACCORDION.allItems.push(accordionItem);
      if (accordionItem.state.opened) {
        ACCORDION.activeItems.push(accordionItem);

        // if (ACCORDION.accordionType !== "any") { // todo: Обязательно протестировать этот момент
        ACCORDION.activeItem = accordionItem;
        // }
      }
    });

    var debouncedUpdate = itsoftApp.utils.debouncer(function () {
      if (ACCORDION.accordion.classList.contains("js-accordion--active")) {
        Array.prototype.forEach.call(ACCORDION.activeItems, function (el) {
          var content = el.accordionContentElement;
          content.style.height = "auto";
          var height = content.clientHeight + "px";
          content.style.height = height;
        });
      }
    }, 500);
    itsoftApp.modules.windowResize.addEvent(function () {
      debouncedUpdate();
    });
  };
  module.callback = Accordion;
});
"use strict";

itsoftApp.createModule("addMoreEls", function () {
  var addMoreButtons = document.querySelectorAll(".js-add-els-button");
  var onAddMoreButtonClick = function onAddMoreButtonClick(evt) {
    evt.preventDefault();
    var target = evt.currentTarget;
    var dataClassName = target.getAttribute("data-class");
    if (dataClassName) {
      var hidedEls = document.querySelectorAll("." + dataClassName);
      if (hidedEls.length > 0) {
        hidedEls.forEach(function (hidedEl) {
          hidedEl.classList.remove(dataClassName);
        });
        target.classList.add("js-hided");
      }
    }
  };
  if (addMoreButtons.length > 0) {
    addMoreButtons.forEach(function (el) {
      el.addEventListener("click", onAddMoreButtonClick);
    });
  }
});
"use strict";

/**
 * Логика поведения фиксированного баннера (banner-fixed)
 * на странице /articles/detail/index.php.
 *
 * Дисклеймер играет главенствующую роль:
 * - Пока он активен (нет классов js-static / js-inactive),
 *   баннер смещён вверх по оси Y на высоту дисклеймера.
 * - Как только дисклеймер становится неактивным (закрыт пользователем
 *   или мы доскроллили до футера), баннер опускается к самому низу экрана.
 *
 * NB: на разрешениях <=1023px у дисклеймера в стилях прописано
 * `+below(desktop) position: fixed !important;` — он визуально остаётся
 * на низу экрана даже с классом js-inactive. Это сознательное решение
 * со стороны вёрстки, баннер на этом разрешении ведёт себя по классам
 * (опускается к низу при js-inactive / js-static, как и до моих правок).
 * Соответствующая компенсация для cookies живёт в disclaimer.js.
 *
 * По оси Z плашка куки всегда выше баннера (см. cookies.styl: z-index: 11
 * и banner-fixed.styl: z-index: 1), поэтому при пересечении
 * куки частично (десктоп) или полностью (мобильный) перекрывает баннер.
 *
 * Координаты пересчитываются:
 * - при скролле документа (на случай, если дисклеймер сменил состояние
 *   из-за приближения к футеру),
 * - при ресайзе окна (вместе с пересчётом высоты дисклеймера),
 * - при изменении классов / inline-стилей дисклеймера через MutationObserver
 *   (чтобы поймать момент закрытия дисклеймера крестиком / кнопкой подтверждения,
 *   когда событий scroll / resize не происходит).
 *
 * У баннера есть кнопка закрытия (.js-banner-close),
 * по клику на которую баннер скрывается, а все слушатели снимаются.
 */
itsoftApp.createModule("bannerFixed", ["pageLoad", "disclaimer", "cookie"], function () {
  var module = this;
  var BannerFixed = function BannerFixed() {
    this.banner = document.querySelector(".js-banner-root");
    this.disclaimer = document.querySelector(".js-disclaimer");
    this.closeButton = null;
    this.observer = null;
    this.gap = 0; /* Зазор между низом дисклеймера и низом баннера. По аналогии с cookies/disclaimer. */
    this.disclaimerHeight = 0;
    this.isClosed = false;
    if (this.banner) {
      this.closeButton = this.banner.querySelector(".js-banner-close");
      this.onScroll = this.updatePosition.bind(this);
      this.onResize = this.onDocumentResize.bind(this);
      this.init();
    }
  };

  /**
   * Баннер ориентируется на классы дисклеймера ровно так же, как раньше делали cookies:
   * нет js-static и нет js-inactive — дисклеймер активен, баннер приподнят.
   *
   * На разрешениях <=1023px дисклеймер визуально остаётся фиксированным даже
   * при js-inactive (см. CSS `+below(desktop) position: fixed !important;`),
   * но это намеренное решение вёрстки: баннер на мобилке опускается к низу,
   * cookies же остаются выше — компенсация для cookies сделана в disclaimer.js.
   */
  BannerFixed.prototype.isDisclaimerActive = function () {
    if (!this.disclaimer) {
      return false;
    }
    return !this.disclaimer.classList.contains("js-static") && !this.disclaimer.classList.contains("js-inactive");
  };

  /**
   * Берём актуальную высоту дисклеймера.
   * Намеренно НЕ полагаемся на itsoftApp.calculations.disclaimerHeight:
   * этот кэш заполняется в disclaimer.js уже после первого checkElementCoords,
   * поэтому до первого скролла кэш может оказаться null и сломать позиционирование.
   * getBoundingClientRect всегда возвращает реальную высоту отрисованного дисклеймера.
   */
  BannerFixed.prototype.getDisclaimerHeight = function () {
    if (!this.disclaimer) {
      return 0;
    }
    return Math.round(this.disclaimer.getBoundingClientRect().height);
  };

  /**
   * Основной метод — выставляет нижнюю координату баннера в зависимости от состояния дисклеймера.
   * Используется и при инициализации, и при скролле, и при ресайзе,
   * и при изменении классов дисклеймера.
   */
  BannerFixed.prototype.updatePosition = function () {
    if (!this.banner || this.isClosed) {
      return;
    }
    if (this.isDisclaimerActive()) {
      this.disclaimerHeight = this.getDisclaimerHeight();
      this.banner.style.bottom = this.disclaimerHeight + this.gap + "px";
    } else {
      /* Дисклеймер неактивен — прижимаем баннер к низу экрана,
         как это делают cookies в disclaimer.js (DISCLAIMER.cookies.style.bottom = 0). */
      this.banner.style.bottom = "0px";
    }
  };

  /**
   * При ресайзе сначала пересчитываем кэшированную высоту дисклеймера,
   * затем уже двигаем баннер. Это страхует от ситуаций,
   * когда наш resize-обработчик отрабатывает раньше windowResize-контроллера.
   */
  BannerFixed.prototype.onDocumentResize = function () {
    if (this.disclaimer && itsoftApp.utils && typeof itsoftApp.utils.getDisclaimerHeight === "function") {
      itsoftApp.utils.getDisclaimerHeight();
    }
    this.updatePosition();
  };

  /**
   * Закрытие баннера по клику на крестик.
   * Скрываем баннер и снимаем все слушатели, чтобы не молотить вхолостую.
   */
  BannerFixed.prototype.close = function () {
    var BANNER = this;
    BANNER.isClosed = true;
    if (BANNER.banner) {
      BANNER.banner.classList.add("is-hidden");
      BANNER.banner.style.display = "none";
    }
    document.removeEventListener("scroll", BANNER.onScroll);
    window.removeEventListener("resize", BANNER.onResize);
    if (BANNER.observer) {
      BANNER.observer.disconnect();
      BANNER.observer = null;
    }
  };
  BannerFixed.prototype.bindCloseButton = function () {
    var BANNER = this;
    if (!BANNER.closeButton) {
      return;
    }
    BANNER.closeButton.addEventListener("click", function (evt) {
      evt.preventDefault();
      BANNER.close();
    });
  };

  /**
   * Дисклеймер может менять состояние не только при скролле/ресайзе,
   * но и при клике на кнопку закрытия / подтверждения внутри disclaimer.js
   * (тогда добавляются классы js-static / js-inactive, и cookie.bottom = 0).
   * Чтобы баннер мгновенно реагировал на это, наблюдаем за изменением classList и style.
   */
  BannerFixed.prototype.observeDisclaimer = function () {
    var BANNER = this;
    if (!BANNER.disclaimer || typeof MutationObserver === "undefined") {
      return;
    }
    BANNER.observer = new MutationObserver(function () {
      BANNER.updatePosition();
    });
    BANNER.observer.observe(BANNER.disclaimer, {
      attributes: true,
      attributeFilter: ["class", "style"]
    });
  };
  BannerFixed.prototype.init = function () {
    var BANNER = this;
    BANNER.bindCloseButton();

    /* Инициализируем модуль после полной загрузки страницы,
       чтобы дисклеймер уже был отрендерен и его высоту можно было корректно измерить. */
    itsoftApp.modules.pageLoad.addEvent(function () {
      /* Первый запуск может прийтись на момент,
         когда дисклеймер ещё дорисовывает себя
         (например, переход из js-inactive в active),
         поэтому повторяем расчёт на следующем кадре. */
      BANNER.updatePosition();
      if (typeof requestAnimationFrame === "function") {
        requestAnimationFrame(function () {
          BANNER.updatePosition();
        });
      }
      document.addEventListener("scroll", BANNER.onScroll);
      window.addEventListener("resize", BANNER.onResize);
      BANNER.observeDisclaimer();
    });
  };
  window.BANNER_FIXED = new BannerFixed();
  module.callback = BannerFixed;
});
"use strict";

itsoftApp.createModule("clipboard", function () {
  itsoftApp.loadScript("/assets/scripts/clipboard.min.js", function () {
    var newClipboard = new ClipboardJS('.js-copy-button');
    var tooltipMini = document.querySelector('.js-copy-tooltip');
    if (tooltipMini) {
      newClipboard.on('success', function (e) {
        e.clearSelection();
        if (!tooltipMini.classList.contains('_show')) {
          tooltipMini.classList.add('_show');
          setTimeout(function () {
            tooltipMini.classList.remove('_show');
          }, 2000);
        }
      });
    }
  });
});
"use strict";

itsoftApp.createModule("cookie", function () {
  var module = this;
  var Cookie = function Cookie() {
    this.MAX_DATE = 2000000000;
    this.SESSION_DATE = 86400;
  };
  Cookie.prototype.setCookie = function (element, date) {
    var dAttrSave = element.getAttribute("data-save");
    var dAttrExpires = element.getAttribute("data-expires");
    if (date) {
      if (date == 'day') {
        document.cookie = dAttrSave + "=yes; path=/; max-age=" + this.SESSION_DATE;
      } else {
        document.cookie = dAttrSave + "=yes; path=/; max-age=" + date;
      }
    } else if (dAttrExpires) {
      if (dAttrExpires === "max") {
        dAttrExpires = this.MAX_DATE;
      }
      document.cookie = dAttrSave + "=yes; path=/; max-age=" + dAttrExpires;
    } else {
      document.cookie = dAttrSave + "=yes; path=/"; /* одна сессия */
    }
  };

  Cookie.prototype.getCookie = function (element) {
    var dAttrSave = element.getAttribute("data-save");
    var matches = document.cookie.match(new RegExp("(?:^|; )" + dAttrSave.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  };
  Cookie.prototype.deleteCookie = function (element) {
    this.setCookie(element, {
      "max-age": -1
    }, "");
  };
  var cookieItem = new Cookie();
  module.setCookie = cookieItem.setCookie;
  module.getCookie = cookieItem.getCookie;
  module.deleteCookie = cookieItem.deleteCookie;
});
"use strict";

/**
 * Кнопки в левом нижнем углу экрана
 * (только в режиме dev)
 *
 * NOTE: Код подключается с доп. командой DEBUG && -
 * это значит, что при минификации скриптов
 * данный модуль будет целиком вырезан, и можно не париться насчёт лишних килобайтов.
 */
DEBUG && itsoftApp.createModule("devBtns", function () {
  var module = this;
  var DevBtns = function DevBtns() {
    this.links = document.querySelectorAll("link");
    this.toggled = false;
    this.init();
  };

  /**
   * Отображение без стилей
   * (полезно для проверки чистой разметки, заголовков, секций и т. п.)
   */
  DevBtns.prototype.checkStyles = function () {
    var link, i, media;
    if (!this.toggled) {
      for (i = this.links.length - 1; i >= 0; i--) {
        link = this.links[i];
        media = link.getAttribute("media");
        if (!media) {
          continue;
        }
        link.setAttribute("data-media", media);
        link.setAttribute("media", "none");
      }
      this.toggled = true;
    } else {
      for (i = this.links.length - 1; i >= 0; i--) {
        link = this.links[i];
        media = link.getAttribute("data-media");
        if (!media) {
          continue;
        }
        link.setAttribute("media", media);
        link.removeAttribute("data-media");
      }
      this.toggled = false;
    }
  };
  DevBtns.prototype.setStyles = function () {
    var DEVBTNS = this;
    var btn = document.querySelector(".js-toggle-styles");
    if (!btn) {
      return false;
    }
    this.toggled = false;
    btn.addEventListener("click", DEVBTNS.checkStyles.bind(DEVBTNS), false);
  };

  /**
   * Отображение без изображений,
   * но так, чтобы был виден текст атрибута alt.
   */
  DevBtns.prototype.checkImages = function () {
    var dAttrSrcOri = "data-src-ori";
    var attrSrc = "src";
    var dAttrSrcsetOri = "data-srcset-ori";
    var attrSrcset = "srcset";
    var i, img;
    var images = document.querySelectorAll("img, source");

    /* находим все изображения, чтобы можно было у них убрать значение атрибута src или srcset */
    /* тем самым мы можем опредлить, из-за каих картинок скачет страница */

    for (i = images.length - 1; i >= 0; i--) {
      img = images[i];
      if (!this.toggled) {
        if (img.hasAttribute(attrSrc)) {
          img.setAttribute(dAttrSrcOri, img.getAttribute(attrSrc));
          img.removeAttribute(attrSrc);
        }
        if (img.hasAttribute(attrSrcset)) {
          img.setAttribute(dAttrSrcsetOri, img.getAttribute(attrSrcset));
          img.removeAttribute(attrSrcset);
        }
      } else {
        if (img.hasAttribute(dAttrSrcOri)) {
          img.setAttribute(attrSrc, img.getAttribute(dAttrSrcOri));
          img.removeAttribute(dAttrSrcOri);
        }
        if (img.hasAttribute(dAttrSrcsetOri)) {
          img.setAttribute(attrSrcset, img.getAttribute(dAttrSrcsetOri));
          img.removeAttribute(dAttrSrcsetOri);
        }
      }
    }
    this.toggled = !this.toggled;
  };
  DevBtns.prototype.setImages = function () {
    var DEVBTNS = this;
    var btn = document.querySelector(".js-toggle-images");
    if (!btn) {
      return false;
    }
    btn.addEventListener("click", DEVBTNS.checkImages.bind(DEVBTNS), false);
  };
  DevBtns.prototype.setListeners = function () {
    this.setStyles();
    this.setImages();
  };
  DevBtns.prototype.init = function () {
    if (!document.querySelector(".js-toggle-styles") && !document.querySelector(".js-toggle-images")) {
      return false;
    }
    this.setListeners();
  };
  new DevBtns();
  module.callback = DevBtns;
});
"use strict";

itsoftApp.createModule("disclaimer", ["pageLoad", "cookie"], function () {
  var module = this;
  var bodyEnd = document.querySelector(".js-padding-bottom");
  var Disclaimer = function Disclaimer() {
    this.scrollTriggerElement = null;
    this.disclaimerWrapper = document.querySelector(".js-disclaimer-wrapper");
    this.scrollSmootherUsed = false;
    this.disclaimerPosition = null; /* сохраняем сюда элемент, где визуально должен находиться дисклеймер в состоянии static или inactive; пока не используется */
    this.footer = document.querySelector(".page-footer");
    this.disclaimer = document.querySelector(".js-disclaimer"); /* У дисклеймера должен быть такой класс */
    this.state = "static";
    this.gap = 0;
    this.cookies = document.querySelector(".js-cookies");
    this.button = document.querySelector(".disclaimer__close-button"); /* Крестик */
    this.confirm = document.querySelector(".disclaimer__confirm"); /* элемент подтвеждения закрытия */
    this.text = document.querySelector(".disclaimer__text");
    this.disclaimerParts = document.querySelectorAll(".disclaimer__part");
    this.footerCoordY;
    this.sTop;
    this.requiredPercentage = 8;
    if (this.disclaimer) {
      this.init();
      this.onScroll = this.onDocumentScroll.bind(this);
      this.onResize = this.onDocumentResize.bind(this);
    }
  };

  /**
   * Возвращает true, если viewport находится в мобильном/планшетном диапазоне (<=1023px).
   * Брейкпоинт совпадает с `+below(desktop)` из вёрстки (desktop = bp-tab-l = 1023px).
   */
  Disclaimer.prototype.isMobileViewport = function () {
    return window.matchMedia("(max-width: 1023px)").matches;
  };

  /**
   * Подставляет плашке cookies правильное значение bottom.
   *
   * На десктопе:
   *   - дисклеймер активен  -> cookies приподнята на высоту дисклеймера;
   *   - дисклеймер неактивен -> cookies прижата к низу экрана (bottom: 0).
   *
   * На мобилке/планшете (<=1023px):
   *   у дисклеймера в стилях стоит `position: fixed !important`, и он
   *   физически остаётся внизу даже при js-inactive / js-static.
   *   Поэтому cookies здесь ВСЕГДА держим выше на высоту дисклеймера —
   *   иначе плашка налезает поверх дисклеймера.
   *
   * @param {boolean} disclaimerVisuallyActive — состояние дисклеймера
   *        с точки зрения класса (active/inactive), как его видит вызывающий код.
   */
  Disclaimer.prototype.applyCookiesBottom = function (disclaimerVisuallyActive) {
    var DISCLAIMER = this;
    if (!DISCLAIMER.cookies) {
      return;
    }
    var keepAboveDisclaimer = disclaimerVisuallyActive || DISCLAIMER.isMobileViewport();
    if (keepAboveDisclaimer) {
      var measuredHeight = DISCLAIMER.disclaimer.getBoundingClientRect().height;
      var height = itsoftApp.calculations.disclaimerHeight || measuredHeight;
      DISCLAIMER.height = height;
      DISCLAIMER.cookies.style.bottom = height + DISCLAIMER.gap + "px";
    } else {
      DISCLAIMER.cookies.style.bottom = "0px";
    }
  };
  Disclaimer.prototype.buttonMouseOver = function () {
    var DISCLAIMER = this;
    if (!this.disclaimer.classList.contains("js-hover")) {
      this.disclaimer.classList.add("js-hover");
      if (this.confirm) {
        this.confirm.addEventListener("mouseleave", DISCLAIMER.buttonMouseOut.bind(DISCLAIMER));
      }
    }
  };
  Disclaimer.prototype.buttonMouseOut = function () {
    var DISCLAIMER = this;
    this.disclaimer.classList.remove("js-hover");
    this.confirm.removeEventListener("mouseleave", DISCLAIMER.buttonMouseOut.bind(DISCLAIMER));
  };
  Disclaimer.prototype.close = function () {
    var DISCLAIMER = this;
    itsoftApp.modules.cookie.setCookie(DISCLAIMER.disclaimer);
    this.state = "static";
    this.disclaimer.classList.add("js-static");
    this.disclaimer.classList.add("js-inactive");
    if (this.disclaimer.classList.contains("js-hover")) {
      this.disclaimer.classList.remove("js-hover");
    }
    if (this.confirm) {
      this.confirm.style.display = "none";
    }
    if (this.disclaimerWrapper) {
      this.disclaimerWrapper.appendChild(this.disclaimer);
    }
    this.footer.classList.add("js-update");
    if (!DISCLAIMER.scrollSmootherUsed) {
      document.removeEventListener("scroll", DISCLAIMER.onScroll);
    }
    window.removeEventListener("resize", DISCLAIMER.onResize);

    /* Сохраняем cookies на высоте дисклеймера на мобиле (там дисклеймер
       всё ещё фиксирован), иначе опускаем к низу экрана. */
    DISCLAIMER.applyCookiesBottom(false);

    // if (bodyEnd) {
    //     bodyEnd.style.paddingBottom = 0;
    // }
  };

  Disclaimer.prototype.checkButton = function () {
    var DISCLAIMER = this;
    if (DISCLAIMER.button) {
      DISCLAIMER.button.addEventListener("mouseover", DISCLAIMER.buttonMouseOver.bind(DISCLAIMER));
      DISCLAIMER.button.addEventListener("click", function (evt) {
        evt.preventDefault();
        this.close = DISCLAIMER.close();
      });
    }
  };
  Disclaimer.prototype.checkConfirm = function () {
    var DISCLAIMER = this;
    if (DISCLAIMER.confirm) {
      DISCLAIMER.confirm.addEventListener("click", function (evt) {
        evt.preventDefault();
        this.close = DISCLAIMER.close();
      });
    }
  };
  Disclaimer.prototype.defineCoordY = function () {
    var DISCLAIMER = this;
    DISCLAIMER.footerCoordY = DISCLAIMER.footer.getBoundingClientRect().top + pageYOffset;
  };

  /* Вычисляем координаты. Если мы прокрутили страницу до подвала, делаем дисклеймер статичным */
  Disclaimer.prototype.checkElementCoords = function () {
    var DISCLAIMER = this;
    var reVerified = false;
    this.sTop = pageYOffset;
    if (this.sTop > 200 && !reVerified) {
      // изредка неправильно определяет координаты сразу после полной загрузки страницы, поэтом нужна одна доп. проверка
      reVerified = true;
      DISCLAIMER.defineCoordY();
    }
    if (this.sTop + document.documentElement.clientHeight > this.footerCoordY) {
      if (this.disclaimerWrapper) {
        this.disclaimerWrapper.appendChild(this.disclaimer);
        DISCLAIMER.defineCoordY();
      }
      if (DISCLAIMER.state != "inactive") {
        DISCLAIMER.state = "inactive";

        // if (bodyEnd) {
        //     bodyEnd.style.paddingBottom = 0;
        // }
      }

      if (this.button) {
        this.button.classList.add("js-close-hide");
      }
      this.disclaimer.classList.add("js-inactive");
      /* На мобиле/планшете дисклеймер визуально остаётся фиксированным
         из-за `+below(desktop) position: fixed !important;`,
         поэтому cookies там нельзя опускать к низу экрана —
         applyCookiesBottom сам учтёт ширину окна. */
      DISCLAIMER.applyCookiesBottom(false);
    } else if (!this.disclaimer.classList.contains("js-static")) {
      if (this.disclaimerWrapper) {
        document.body.appendChild(this.disclaimer);
        DISCLAIMER.defineCoordY();
      }
      if (DISCLAIMER.state != "active") {
        DISCLAIMER.state = "active";

        // if (!itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight) {
        //     itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight = true;
        //     itsoftApp.calculations.disclaimerHeight = itsoftApp.utils.getDisclaimerHeight();
        // }

        // if (bodyEnd) {
        //     bodyEnd.style.paddingBottom = itsoftApp.calculations.disclaimerHeight + "px";
        // }
      }

      if (this.button) {
        this.button.classList.remove("js-close-hide");
      }
      this.disclaimer.classList.remove("js-inactive");
      /* Дисклеймер активен — cookies должна стоять выше на его высоту.
         applyCookiesBottom сам подстрахует через getBoundingClientRect,
         если itsoftApp.calculations.disclaimerHeight ещё не успел заполниться. */
      DISCLAIMER.applyCookiesBottom(true);
    }
  };
  Disclaimer.prototype.onDocumentScroll = function () {
    var DISCLAIMER = this;
    DISCLAIMER.checkElementCoords();
  };
  Disclaimer.prototype.onDocumentResize = function () {
    /* Обновляем координаты при ресайзе */
    var DISCLAIMER = this;
    DISCLAIMER.calcFontSize();
    DISCLAIMER.defineCoordY();
    /* Передаём текущее активное состояние по классам;
       applyCookiesBottom сам решит, нужно ли всё равно поднимать cookies
       (на мобилке — да, независимо от классов). */
    DISCLAIMER.applyCookiesBottom(DISCLAIMER.state === "active");
    DISCLAIMER.checkElementCoords();
  };
  Disclaimer.prototype.init = function () {
    var DISCLAIMER = this;
    if (DISCLAIMER.disclaimer) {
      /* Инициализируем модуль после полной загрузки страницы, только если на странице есть дисклеймер */
      itsoftApp.modules.pageLoad.addEvent(function () {
        if (DISCLAIMER.disclaimerWrapper) {
          DISCLAIMER.disclaimerPosition = DISCLAIMER.disclaimerWrapper;
        } else {
          DISCLAIMER.disclaimerPosition = DISCLAIMER.disclaimer;
        }
        DISCLAIMER.calcFontSize();
        DISCLAIMER.dAttrSave = DISCLAIMER.disclaimer.getAttribute("data-save");
        if (!DISCLAIMER.dAttrSave || DISCLAIMER.dAttrSave && !itsoftApp.modules.cookie.getCookie(DISCLAIMER.disclaimer)) {
          DISCLAIMER.defineCoordY();
          DISCLAIMER.checkElementCoords();
        } else {
          DISCLAIMER.state = "static";
          if (DISCLAIMER.disclaimerWrapper) {
            DISCLAIMER.disclaimerWrapper.appendChild(DISCLAIMER.disclaimer);
            DISCLAIMER.defineCoordY();
          }
          return;
        }
        if (bodyEnd) {
          if (!itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight) {
            itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight = true;
            itsoftApp.calculations.disclaimerHeight = itsoftApp.utils.getDisclaimerHeight();
          }
          bodyEnd.style.paddingBottom = itsoftApp.calculations.disclaimerHeight + "px";
        }
        if (DISCLAIMER.sTop + document.documentElement.clientHeight > DISCLAIMER.footerCoordY) {
          DISCLAIMER.state = "inactive";
        } else {
          if (!itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight) {
            itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight = true;
            itsoftApp.calculations.disclaimerHeight = itsoftApp.utils.getDisclaimerHeight();
          }
          DISCLAIMER.state = "active";
        }

        /* DISCLAIMER.height нужен и без disclaimerWrapper —
           на него опирается блок выставления cookies.style.bottom внутри applyCookiesBottom. */
        DISCLAIMER.height = DISCLAIMER.disclaimer.getBoundingClientRect().height;
        if (DISCLAIMER.disclaimerWrapper) {
          DISCLAIMER.disclaimerWrapper.style.height = DISCLAIMER.height + "px";
        }

        /* Финализируем стартовое положение cookies: applyCookiesBottom
           сам разрулит десктоп/мобилку и активное/неактивное состояние. */
        DISCLAIMER.applyCookiesBottom(DISCLAIMER.state === "active");
        document.addEventListener("scroll", DISCLAIMER.onScroll);
        /* todo: доработать, достать из itsoftApp.calculations.disclaimerHeight */
        window.addEventListener("resize", DISCLAIMER.onResize);
      });
      DISCLAIMER.checkButton();
      DISCLAIMER.checkConfirm();
    }
  };
  Disclaimer.prototype.getWordsSquare = function () {
    var square = 0;
    Array.prototype.forEach.call(this.disclaimerParts, function (word) {
      var blockW = word.clientWidth;
      var blockH = word.clientHeight;
      var currentSquare = blockW * blockH;
      square += currentSquare;
    });
    return square;
  };
  Disclaimer.prototype.getWindowSquare = function () {
    var bodyWidth = itsoftApp.utils.getViewportSize();
    var bodyHeight = itsoftApp.utils.getViewportHeight();
    return bodyWidth * bodyHeight;
  };
  Disclaimer.prototype.getFinalValue = function (square) {
    var percent = square * 100 / this.getWindowSquare();
    return percent > this.requiredPercentage;
  };
  Disclaimer.prototype.setFontSize = function (size) {
    this.text.style.fontSize = size + "px";
    this.text.setAttribute("data-font-size", size);
  };
  Disclaimer.prototype.getFontSize = function () {
    return parseInt(this.text.getAttribute("data-font-size"), 10) || 8;
  };
  Disclaimer.prototype.calcFontSize = function () {
    var DISCLAIMER = this;
    var counter = 0;
    DISCLAIMER.setFontSize(8);
    while (this.getFinalValue(this.getWordsSquare(), this.requiredPercentage) === false) {
      if (counter++ > 100) break;
      DISCLAIMER.setFontSize(DISCLAIMER.getFontSize() + 2);
    }
    var fontSize = this.getFontSize();
    this.text.style.fontSize = fontSize + "px";
  };
  window.DISCLAIMER = new Disclaimer();
  module.callback = Disclaimer;
});
"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
itsoftApp.createModule("filters", function () {
  var module = this;
  var init = function init(filtersSection, cb) {
    var filtersForm = filtersSection.querySelector(".js-filters");
    var filtersBlocks = filtersSection.querySelectorAll(".js-filter-block");
    var filtersAllItemsWithoutAllButton = filtersSection.querySelectorAll(".js-filter-item:not(.js-filter-item--all)");
    var resetAllFilters = function resetAllFilters(cb) {
      Array.prototype.forEach.call(filtersAllItemsWithoutAllButton, function (item) {
        item.checked = false;
      });
      cb();
    };
    var filtersNameMap = {};
    var initFilterBlock = function initFilterBlock(filterBlock) {
      var filtersItems = filterBlock.querySelectorAll(".js-filter-item");
      var filtersAllItem = filterBlock.querySelector(".js-filter-item--all");
      var filtersItemsWithoutAll = filterBlock.querySelectorAll(".js-filter-item:not(.js-filter-item--all)");
      var filtersLabels = filterBlock.querySelectorAll(".js-filter-label");
      var resetButton = filterBlock.querySelector(".js-reset-button");
      var filterName = filtersItems.length > 0 && filtersItems[0].name;
      var changeFilter = function changeFilter() {
        var checkedFilters = Array.prototype.filter.call(filtersItemsWithoutAll, function (item) {
          return item.checked;
        });
        if (filtersAllItem) {
          if (checkedFilters.length > 0) {
            filtersAllItem.disabled = false;
            filtersAllItem.removeAttribute("checked");
            filtersAllItem.checked = false;
          } else {
            filtersAllItem.disabled = true;
            filtersAllItem.checked = true;
          }
        }
      };
      var isAllButton = function isAllButton(filterItem) {
        return filterItem.classList.contains("js-filter-item--all") ? true : false;
      };

      // const resetFilters = function () {
      //   if (filtersAllItem) {
      //     filtersAllItem.checked = true;
      //     filtersAllItem.disabled = true;
      //   }

      //   Array.prototype.forEach.call(filtersItemsWithoutAll, function (item) {
      //     item.checked = false;
      //   });

      //   createRequest();
      // }

      var resetFilters = function resetFilters() {
        resetAllFilters(createRequest);
      };
      var createRequest = function createRequest() {
        var allFiltersValues = [];
        allFiltersValues = Array.prototype.reduce.call(filtersBlocks, function (acc, filterBlock) {
          var allFiltersItems = filterBlock.querySelectorAll(".js-filter-item") || [];
          var allCheckedFilters = Array.prototype.filter.call(allFiltersItems, function (item) {
            return item.checked;
          }) || [];
          if (allCheckedFilters.length > 0) {
            acc.push({
              name: filterBlock.getAttribute("name") || filterBlock.getAttribute("data-name") || allCheckedFilters[0].name,
              value: Array.prototype.map.call(allCheckedFilters, function (checkedFilter) {
                return checkedFilter.value;
              })
            });
          }
          return acc;
        }, []);
        debouncer(allFiltersValues);
      };
      module.createRequest = createRequest;
      var entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;'
      };
      var escapeHtml = function escapeHtml(string) {
        return String(string).replace(/[&<>"'`=\/]/g, function (s) {
          return entityMap[s];
        });
      };
      var sendRequest = function sendRequest(allFiltersValues) {
        var url = "?";
        if (allFiltersValues.length === 0) {
          url = "";
        }
        Array.prototype.forEach.call(allFiltersValues, function (filterValue, index, arr) {
          var selectName = filterValue.name;
          var selectValue = filterValue.value.join(';');
          url += selectName + "=" + selectValue;
          if (index < arr.length - 1) {
            url += '&';
          }
        });

        // if (url !== "") {
        url = escapeHtml(url);
        url.replace(/\s/g, '+');
        var action = filtersForm.getAttribute("action");
        var query = action + url;
        history.pushState("", "", url);
        cb(null, query);
        // }
      };

      var debouncer = itsoftApp.utils.debouncer(sendRequest, 500);
      resetButton && resetButton.addEventListener("click", resetFilters);
      Array.prototype.forEach.call(filtersItems, function (filterItem, index) {
        filterItem.addEventListener("change", function (evt) {
          var target = evt.currentTarget;
          if (isAllButton(filterItem)) {
            resetFilters();
            return;
          }
          changeFilter(target);
          createRequest();
        });
      });
      if (filterName && filtersNameMap[filterName]) {
        Array.prototype.forEach.call(filtersNameMap[filterName], function (filterValue) {
          var filterItem = filterBlock.querySelector('[value="' + filterValue + '"]');
          if (filterItem) {
            filterItem.checked = true;
          }
        });
      }

      /* --- */

      Array.prototype.forEach.call(filtersLabels, function (filtersLabel) {
        filtersLabel.addEventListener("keyup", function (evt) {
          if (evt.keyCode !== 13) {
            return;
          }
          var target = evt.currentTarget;
          var filterItem = target.closest(".js-filter-wrapper").querySelector(".js-filter-item");
          if (isAllButton(filterItem)) {
            resetFilters();
            return;
          }
          if (filterItem.checked) {
            filterItem.removeAttribute("checked");
            filterItem.checked = false;
          } else {
            filterItem.checked = true;
          }
          changeFilter(filterItem);
          createRequest();
        });
      });
    };
    var url = window.location.href;
    var parseFiltersFromUrl = function parseFiltersFromUrl(url) {
      // 1. Получаем часть после '?'
      var queryString = url.split('?')[1];
      if (!queryString) return {};

      // 2. Делим по '&' на отдельные параметры
      var params = queryString.split('&');
      var filtersObj = {};
      params.forEach(function (param) {
        // 3. Делим каждый параметр на ключ и значение по '='
        var _param$split = param.split('='),
          _param$split2 = _slicedToArray(_param$split, 2),
          key = _param$split2[0],
          value = _param$split2[1];
        if (!key || !value) return;

        // 4. Делим значение по ';' и сохраняем в объект
        filtersObj[key] = value.split(';');
      });
      return filtersObj;
    };
    filtersNameMap = parseFiltersFromUrl(url);
    Array.prototype.forEach.call(filtersBlocks, function (filterBlock) {
      initFilterBlock(filterBlock);
    });
    module.createRequest();
  };

  // module.callback = initFilters;/
  module.init = init;
});
"use strict";

itsoftApp.createModule("focusVisible", function () {
  /* Эмулирем на JS псевдокласс focus-visible, так как некоторые браузеры его не поддерживают */
  /* При клике с помощью мышки или пальца не будут срабатывать стили для :focus */
  var module = this;
  var FocusVisible = function FocusVisible() {
    this.path = "/assets/scripts/focus-visible/focus-visible.min.js";
    this.init();
  };
  FocusVisible.prototype.init = function () {
    itsoftApp.loadScript(this.path);
  };
  new FocusVisible();
  module.callback = FocusVisible;
});
"use strict";

itsoftApp.createModule("headerFix", ["pageLoad", "windowScroll", "windowResize"], function () {
  var module = this;
  var Header = function Header() {
    this.header = document.querySelector(".page-header");
    this.pageWrapper = document.querySelector(".l-wrapper");
    this.headerFixed = false;
    this.paddingElems = document.querySelectorAll(".js-padding");
    this.headerHeight;
    this.init();
  };
  Header.prototype.setPagePadding = function () {
    var HEADER = this;
    // учитывается, что высота шапки может поменяться по мере скролла, поэтому нужно измерить высоту шапки в нормальном состоянии

    if (HEADER.paddingElems) {
      Array.prototype.forEach.call(HEADER.paddingElems, function (el) {
        el.style.paddingTop = itsoftApp.calculations.headerStaticHeight + "px";
      });
    } else {
      HEADER.pageWrapper.style.paddingTop = itsoftApp.calculations.headerStaticHeight + "px";
    }
  };
  Header.prototype.updHeaderHeightAndPadding = function () {
    var HEADER = this;
    if (HEADER.header) {
      HEADER.header.classList.remove("js-fixed");
      if (!itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.headerHeight) {
        itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.headerHeight = true;
        itsoftApp.calculations.headerHeight = itsoftApp.utils.getHeaderHeight();
      }
      HEADER.headerHeight = itsoftApp.calculations.headerHeight;
      if (pageYOffset !== 0) {
        HEADER.header.classList.add("js-fixed");
      }
      HEADER.setPagePadding();
    }
  };
  Header.prototype.modifyHeader = function () {
    var HEADER = this;
    if (pageYOffset > 0 && !HEADER.headerFixed) {
      HEADER.header.classList.add("js-fixed");
      HEADER.headerFixed = true;
    } else if (pageYOffset === 0) {
      HEADER.header.classList.remove("js-fixed");
      HEADER.headerFixed = false;
    }
  };
  Header.prototype.init = function () {
    var HEADER = this;
    if (HEADER.header) {
      itsoftApp.modules.pageLoad.addEvent(function () {
        HEADER.headerHeight = itsoftApp.utils.getHeaderHeight();
        if (pageYOffset > 0 && !HEADER.headerFixed) {
          itsoftApp.utils.getHeaderStaticHeight();
          HEADER.header.classList.add("js-fixed");
          HEADER.headerFixed = true;
          itsoftApp.utils.getHeaderFixedHeight();
        } else if (pageYOffset === 0) {
          itsoftApp.utils.getHeaderStaticHeight();
          itsoftApp.utils.getHeaderFixedHeight(); // TODO: надо оптимизировать лишнее вычисление
          // HEADER.header.classList.remove("js-fixed");
          HEADER.headerFixed = false;
        }
        itsoftApp.modules.windowResize.addEvent(HEADER.updHeaderHeightAndPadding.bind(HEADER));
        itsoftApp.modules.windowScroll.addEvent(HEADER.modifyHeader.bind(HEADER));
        HEADER.modifyHeader();
        HEADER.setPagePadding();
        if (HEADER.header.hasAttribute("data-default")) {
          HEADER.header.removeAttribute("data-default");
        }
      });
    }
  };
  new Header();
  module.callback = Header;
});
"use strict";

itsoftApp.createModule("infoBox", function () {
  var module = this;
  var init = function init(el) {
    var infoButtons = el.querySelectorAll("[data-info]");
    var generalClose = null;
    if (!infoButtons.length) {
      return;
    }
    var onBoxClick = function onBoxClick(evt) {
      var box = evt.currentTarget;
      var boxArea = evt.target;
      if (!boxArea.closest(".info-box__content")) {
        box.closest("[data-info-parent]").classList.remove("js-index");
        box.classList.remove("js-hover");
        box.classList.remove("js-active");
      }
    };
    var onBoxOver = function onBoxOver(evt) {
      var box = evt.currentTarget;
      box.closest("[data-info-parent]").classList.add("js-index");
      box.classList.add("js-active");
      box.classList.add("js-hover");
    };
    var onBoxOut = function onBoxOut(evt) {
      var box = evt.currentTarget;
      box.closest("[data-info-parent]").classList.remove("js-index");
      box.classList.remove("js-hover");
      // box.removeEventListener("click", onBoxClick);
    };

    var onButtonOver = function onButtonOver(evt) {
      var target = evt.currentTarget;
      var id = target.getAttribute("data-info");
      var box = document.querySelector("[data-box='" + id + "']");
      target.closest("[data-info-parent]").classList.add("js-index");
      box.classList.add("js-active");
      box.classList.add("js-hover");
      // box.addEventListener("click", onBoxClick);
    };

    var onButtonOut = function onButtonOut(evt) {
      var target = evt.currentTarget;
      var id = target.getAttribute("data-info");
      var box = document.querySelector("[data-box='" + id + "']");
      // if (!box.classList.contains("js-active")) {
      target.closest("[data-info-parent]").classList.remove("js-index");
      // }
      box.classList.remove("js-hover");
      // box.removeEventListener("click", onBoxClick);
    };

    var onCloseButtonClick = function onCloseButtonClick(evt) {
      evt.preventDefault();
      var target = evt.currentTarget;
      target.closest("[data-info-parent]").classList.remove("js-index");
      target.closest("[data-box]").classList.remove("js-active");
      target.closest("[data-box]").classList.remove("js-hover");
      // target.removeEventListener("click", onBoxClick);
    };

    var onGeneralCloseButtonClick = function onGeneralCloseButtonClick() {
      evt.preventDefault();
      var target = evt.currentTarget;
      target.closest("[data-info-parent]").classList.remove("js-index");
      target.closest("[data-info-parent]").classList.remove("js-active");
      infoButtons.forEach(function (button) {
        var id = button.getAttribute("data-info");
        var box = document.querySelector("[data-box='" + id + "']");
        box.classList.remove("js-active");
        box.classList.remove("js-hover");
      });
    };
    infoButtons.forEach(function (button) {
      var id = button.getAttribute("data-info");
      var box = document.querySelector("[data-box='" + id + "']");
      var closeBtn = box.querySelector("[data-close]");
      closeBtn && closeBtn.addEventListener("click", onCloseButtonClick);
      button.addEventListener("mouseover", onButtonOver);
      button.addEventListener("mouseout", onButtonOut);
      box.addEventListener("mouseover", onBoxOver);
      box.addEventListener("mouseout", onBoxOut);
    });
  };
  module.init = init;
});
// itsoftApp.createModule("insertUtekaSlider", ["utekaInit"], function () {
//     var module = this;
//     var insertUtekaSlider = function () {
//         var widget = document.querySelector(".js-uteka-widget-slider")
//         if (widget) {
//             window.uteka.loadWidgetPre(widget, {
//                 productId: "358501"
//             })
//         }
//     };

//     module.callback = insertUtekaSlider
// });
"use strict";
"use strict";

itsoftApp.createModule("lazyLoading", ["windowResize", "windowScroll", "scrollTo"], function () {
  var module = this;
  window.lazyQueue = [];
  window.lazyInitQueue = function () {
    if (!window.lazyQueue.length) {
      return;
    }
    while (window.lazyQueue.length > 0) {
      // Взять первый элемент массива,
      // и вызвать его. Мы уже знаем, что это функция,
      // поэтому доп. проверка не требуется.
      window.lazyQueue.shift()();
    }
  };
  var checking = false;
  window.lazyFunctions = {
    slider: function slider(element) {
      var sliderSettingsKey = element.getAttribute("data-slider-settings"); // получаем data-атрибут
      var sliderSettingsObject = itsoftApp.modules.slidersSettings.getSettings(sliderSettingsKey); // получаем объект конфига

      if (sliderSettingsKey && sliderSettingsObject) {
        new itsoftApp.modules.slidersLibrary.callback(element, sliderSettingsObject);
      } else {
        new itsoftApp.modules.slidersLibrary.callback(element);
      }
    },
    tabs: function tabs(element) {
      new itsoftApp.modules.toggleTabs.callback.init(element);
    },
    takeAnim: function takeAnim(element) {
      itsoftApp.modules.takeAnim.init(element);
    },
    scrollTrigger: function scrollTrigger(element) {
      itsoftApp.modules.scrollActions.callback(element, true, false);
    },
    accordion: function accordion(element) {
      new itsoftApp.modules.accordion.callback(element);
    },
    loadItems: function loadItems(element) {
      itsoftApp.modules.loadItems.initLoad(element);
    },
    loadItemsWithFilters: function loadItemsWithFilters(element) {
      itsoftApp.modules.loadItemsWithFilters.initLoad(element);
    },
    uteka: function uteka(element) {
      itsoftApp.modules.uteka.callback(element);
    },
    videoPopup: function videoPopup(element) {
      itsoftApp.modules.videoPopup.init(element);
    },
    infoBox: function infoBox(element) {
      itsoftApp.modules.infoBox.init(element);
    },
    sequence: function sequence(element) {
      var onDocumentScroll = function onDocumentScroll() {
        DEBUG && console.log(element.getBoundingClientRect().top, ' lement.getBoundingClientRect().top');
        if (element.getBoundingClientRect().top > 0) {
          window.removeEventListener("scroll", onDocumentScroll);
          LazyLoad.resetStatus(element);
          window.llCallback.update();
        }
      };
      if (itsoftApp.libraries.scrollToPlugin.active || itsoftApp.state.hashActive) {
        lazyQueue.push(function () {
          window.addEventListener("scroll", onDocumentScroll);
        });
      } else {
        itsoftApp.modules.sequence.callback(element, true, false);
      }
    },
    social: function social(element) {
      itsoftApp.modules.social.init(element);
    },
    videoAutoplay: function videoAutoplay(element) {
      itsoftApp.modules.videoAutoplay.init(element);
    }
  };
  window.lazyLoadedFunctions = {
    videoAutoplay: function videoAutoplay(element) {
      itsoftApp.modules.videoAutoplay.init(element);
    }
  };
  function executeLazyFunction(element) {
    var lazyFunctionName = element.getAttribute("data-lazy-function");
    var lazyFunction = window.lazyFunctions[lazyFunctionName];
    if (!lazyFunction) return;
    lazyFunction(element);
  }
  function executeLazyLoadedFunction(element) {
    var lazyFunctionName = element.getAttribute("data-lazy-loaded-function");
    var lazyFunction = window.lazyLoadedFunctions[lazyFunctionName];
    if (!lazyFunction) return;
    lazyFunction(element);
  }
  var Lazy = function Lazy() {
    this.path = "/assets/scripts/vanilla-lazyload/lazyload.min.js";
    this.init();
  };
  Lazy.prototype.setSettings = function () {
    window.llEarlier = new LazyLoad({
      // eslint-disable-line
      unobserve_entered: true,
      // eslint-disable-line
      elements_selector: ".lazyload-earlier",
      // eslint-disable-line
      class_loaded: "loaded",
      // eslint-disable-line,
      class_entered: "entered",
      thresholds: "-100% 0px" // eslint-disable-line,
    });

    window.ll = new LazyLoad({
      // eslint-disable-line
      // unobserve_entered: true, // eslint-disable-line
      elements_selector: ".lazy, .lazyload",
      // eslint-disable-line
      class_loaded: "loaded",
      // eslint-disable-line,
      class_entered: "entered",
      // eslint-disable-line,
      cancel_on_exit: true
    });
    window.llCallRequestOptions = {
      // eslint-disable-line
      unobserve_entered: true,
      // eslint-disable-line
      class_loaded: "loaded",
      // eslint-disable-line,
      class_entered: "entered" // eslint-disable-line,
    };

    window.llCallRequest = new LazyLoad(window.modalOptions);
    window.llCallback = new LazyLoad({
      // eslint-disable-line
      unobserve_entered: true,
      // eslint-disable-line
      elements_selector: ".lazy-script, .js-script",
      // eslint-disable-line
      class_entered: "js-script-entered",
      // eslint-disable-line,
      callback_enter: executeLazyFunction
    });
    new LazyLoad({
      // eslint-disable-line
      unobserve_entered: true,
      // eslint-disable-line
      elements_selector: ".js-anim",
      // eslint-disable-line
      class_entered: "js-anim--show",
      // eslint-disable-line,
      thresholds: "-15% 0px"
    });
    window.llLoadedCallback = new LazyLoad({
      // eslint-disable-line
      unobserve_entered: true,
      // eslint-disable-line
      elements_selector: ".lazy-with-cb, .lazyload-with-cb",
      // eslint-disable-line
      class_loaded: "loaded",
      // eslint-disable-line,
      class_entered: "entered",
      // eslint-disable-line,
      callback_loaded: executeLazyLoadedFunction
    });
  };
  Lazy.prototype.init = function () {
    itsoftApp.loadScript(this.path, this.setSettings);
  };
  new Lazy();
  module.callback = Lazy;
});
"use strict";

/* globals Raven */

/**
 * Отмена действия по умолчанию для ссылок с атрибутом href="#".
 * В нашей заготовки таковыми являются ссылки, для которых предполагается реальный href,
 * но который на вёрстке ещё не известен.
 * Если не отменить для таких ссылок действие по умолчанию,
 * то при клике страница перепрыгнет на самый верх, а в адресной строке появится #.
 *
 * NOTE: Также данный модуль отправляет сообщения в логгер, если подобные ссылки
 * найдены на продакт-сервере (там вместо # должны быть проставлены реальные адреса).
 */
itsoftApp.createModule("linksWithHash", function () {
  var module = this;
  var LinksWithHash = function LinksWithHash() {
    this.links = document.querySelectorAll("a[href='#']");
    this.isLocal = itsoftApp.isLocal;
    this.init();
  };

  /**
   * Простой обрабочик, который отменяет действие по умолчанию
   *
   * @param  {object} e Event
   */
  LinksWithHash.prototype.linksWithHashHandler = function (e) {
    e.preventDefault();
    DEBUG && console.log("[module linksWithHash] default action prevented for link");
  };

  // Привязка функций к событиям
  LinksWithHash.prototype.addListener = function () {
    var LINKSWITHHASH = this;
    for (var i = 0, len = LINKSWITHHASH.links.length, link; i < len; i++) {
      link = LINKSWITHHASH.links[i];
      link.addEventListener("click", LINKSWITHHASH.linksWithHashHandler.bind(LINKSWITHHASH), false);
    }
  };

  // Если на боевом сервере найдены ссылки с атрибутом href="#",
  // то отправляем в логгер сообщение об ошибке,
  // так как там уже должны быть настоящие ссылки вместо заглушек.
  LinksWithHash.prototype.checkRaven = function () {
    if (typeof Raven !== "undefined" && !this.isLocal) {
      var extra = {};

      // Формируем объект, в котором перечислены все найденные ссылки,
      // причём с указанием их html-кода
      // (для того, чтобы можно было определить, какие именно ссылки найдены, точно ли это ошибка или нет)
      Array.prototype.forEach.call(this.links, function (link, index) {
        var html = link.outerHTML;
        extra["link" + (index + 1)] = html;
      });
      Raven.captureMessage("[module linksWithHash] links with href='#' found", {
        level: "warning",
        // one of 'info', 'warning', or 'error'
        extra: extra
      });
    }
  };
  LinksWithHash.prototype.init = function () {
    if (!this.links.length) {
      return false;
    }
    DEBUG && console.log("%c[module linksWithHash] " + this.links.length + " links with href='#' found. is it ok for this page?? maybe you need to replace '#' with normal link? check it.", "color: orange");
    this.addListener();
    this.checkRaven();
  };
  new LinksWithHash();
  module.callback = LinksWithHash;
});
"use strict";

itsoftApp.createModule("loadItems", function () {
  var module = this;
  var mobileWidth = 1023;
  var defaultItemsCount = null;
  var mobileItemsCount = null;
  var initLoad = function initLoad(section) {
    // window.viewWidth = itsoftApp.commonVars.viewWidth ? itsoftApp.commonVars.viewWidth : itsoftApp.utils.getViewportSize();
    window.defaultItemsCount = defaultItemsCount = section.getAttribute("data-default-items-count") || 4;
    window.mobileItemsCount = mobileItemsCount = section.getAttribute("data-default-items-count") || 4;
    var filters = section.querySelector(".js-filters"); //
    var sorting = section.querySelector(".js-sorting"); //
    var loadTarget = section.querySelector(".js-load-target");
    var loadTrigger = section.querySelector(".js-load");
    var loadTriggerParent;
    var url;
    var filtersInited = false; //

    loadTriggerParent = section.querySelector(".js-load-parent") || loadTrigger && loadTrigger.parentNode;
    var pagination = section.querySelector(".js-pagination");
    var paginationParent;
    if (pagination) {
      paginationParent = pagination.parentNode;
    }
    var sendRequest = function sendRequest(onSuccess, onError, flag, withFilters) {
      var xhr = new XMLHttpRequest();
      xhr.addEventListener("load", function () {
        if (xhr.status === 200 && onSuccess) {
          if (flag) {
            DEBUG && console.log(xhr.response, ' xhr.response');
            onSuccess(xhr.response, flag);
          }
        } else {
          DEBUG && console.log(xhr.response, ' xhr.response ERRORE');
          onError(xhr.response);
        }
      });
      xhr.addEventListener("error", function () {
        onError("Произошла ошибка соединения");
      });
      xhr.addEventListener("timeout", function () {
        onError("Запрос не успел выполниться за " + xhr.timeout + "мс");
      });
      xhr.timeout = 10000;
      if (withFilters) {
        DEBUG && console.log('YES, with filters');
        var filtersSection = section;
        var filtersForm = filtersSection.querySelector(".js-filters");
        var exIds = filtersForm.querySelector("[name='ex_ids']");
        var filtersBlocks = filtersSection.querySelectorAll(".js-filter-block");
        var allFiltersValues = [];
        allFiltersValues = Array.prototype.map.call(filtersBlocks, function (filterBlock) {
          var allFiltersItems = filterBlock.querySelectorAll(".js-filter-item") || [];
          var allCheckedFilters = Array.prototype.filter.call(allFiltersItems, function (item) {
            return item.checked;
          }) || [];
          return {
            name: filterBlock.getAttribute("name") || filterBlock.getAttribute("data-name") || allCheckedFilters[0].name,
            value: Array.prototype.map.call(allCheckedFilters, function (checkedFilter) {
              return checkedFilter.value;
            })
          };
        });
        if (url.indexOf('?') == -1) {
          url += "?";
        } else {
          url += "&";
        }
        Array.prototype.forEach.call(allFiltersValues, function (filterValue, index, arr) {
          var selectName = filterValue.name;
          var selectValue = filterValue.value.join(';');
          url += selectName + "=" + selectValue;
          if (index < arr.length - 1) {
            url += '&';
          }
        });

        // if (viewWidth > mobileWidth) {
        url += '&' + 'amount' + "=" + defaultItemsCount;
        // } else {
        //     url += '&' + 'amount' + "=" + mobileItemsCount;
        // }

        if (exIds) {
          url += '&';
          url += exIds.name + "=" + exIds.value;
        }
        url.replace(/\s/g, '+');
      }

      /* */

      xhr.open("GET", url);
      xhr.send();
    };
    var onErrorLoad = function onErrorLoad(data) {
      DEBUG && console.log("error ", data);
    };
    var removeOldDataFromPage = function removeOldDataFromPage() {
      var cards = loadTarget.querySelectorAll(".js-load-item");
      for (var i = 0; i < cards.length; i++) {
        cards[i].parentNode.removeChild(cards[i]);
      }
    };
    var removeOldNavFromPage = function removeOldNavFromPage() {
      pagination = section.querySelector(".js-pagination");
      if (pagination) {
        paginationParent.removeChild(pagination);
      }
    };
    var addNewDataToPage = function addNewDataToPage(wrapper) {
      var newElements = wrapper.querySelectorAll(".js-load-item");
      if (newElements.length > 0) {
        var fragment = document.createDocumentFragment();

        /*** ***/
        var isAccordion = wrapper.querySelector(".js-accordion");
        if (isAccordion) {
          new itsoftApp.modules.accordion.callback(isAccordion);
        }

        /*** ***/

        Array.prototype.forEach.call(newElements, function (newElement) {
          fragment.appendChild(newElement);
        });
        loadTarget.appendChild(fragment);
      }
    };
    var addNewNavToPage = function addNewNavToPage(wrapper) {
      var newPagination = wrapper.querySelector(".js-pagination");
      var newLoadTrigger = wrapper.querySelector(".js-load");
      if (newPagination) {
        var newPaginationLinks = newPagination.querySelectorAll(".js-pagination-link");
        if (newPaginationLinks.length > 0) {
          Array.prototype.forEach.call(newPaginationLinks, function (newPaginationLink) {
            if (newPaginationLink.hasAttribute("href") || newPaginationLink.hasAttribute("data-href")) {
              newPaginationLink.addEventListener("click", onTogglePageClick);
            }
          });
        }
        paginationParent.appendChild(newPagination);
      }
      if (newLoadTrigger && loadTriggerParent && loadTrigger) {
        if (loadTriggerParent.classList.contains("g-hidden")) {
          loadTriggerParent.classList.remove("g-hidden");
        }
        if (newLoadTrigger.hasAttribute("href")) {
          loadTrigger.href = newLoadTrigger.href;
        } else if (newLoadTrigger.hasAttribute("data-href")) {
          loadTrigger.setAttribute("data-href", newLoadTrigger.getAttribute("data-href"));
        }
      } else {
        if (loadTriggerParent && loadTrigger) {
          loadTriggerParent.classList.add("g-hidden");
        } else if (loadTriggerParent && newLoadTrigger) {
          loadTriggerParent.appendChild(newLoadTrigger);
          newLoadTrigger.addEventListener("click", onLoadTriggerClick);
          loadTrigger = newLoadTrigger;
        }
      }
    };
    var onSuccessToggle = function onSuccessToggle(data, scrolling) {
      var wrapper = document.createElement("div");
      wrapper.innerHTML = data;
      var slider = loadTarget.classList.contains("swiper-wrapper");
      if (slider) {
        var slides = wrapper.querySelectorAll(".swiper-slide");
        var sliderArticles = document.querySelector('[data-slider-name="articles"]');
        updSlider(sliderArticles, slides);
      } else {
        removeOldDataFromPage();
        addNewDataToPage(wrapper);
      }
      removeOldNavFromPage();
      addNewNavToPage(wrapper);
      if (scrolling) {
        itsoftApp.modules.animateScroll.callback(loadTarget, null, 500, 500, "easeInOutQuad", 15);
      }
    };
    var onSuccessLoad = function onSuccessLoad(data) {
      var wrapper = document.createElement("div");
      wrapper.innerHTML = data;
      removeOldNavFromPage();
      addNewDataToPage(wrapper);
      addNewNavToPage(wrapper);
    };
    var onLoadTriggerClick = function onLoadTriggerClick(evt) {
      evt.preventDefault();
      var button = evt.currentTarget;
      url = button.getAttribute("href") || button.getAttribute("data-href");
      if (loadTrigger.classList.contains("js-load-with-filters")) {
        sendRequest(onSuccessLoad, onErrorLoad, true, true);
      } else {
        sendRequest(onSuccessLoad, onErrorLoad, true);
      }
    };
    var onLoadImmediately = function onLoadImmediately() {
      var button = loadTrigger;
      url = button.getAttribute("href") || button.getAttribute("data-href");
      if (loadTrigger.classList.contains("js-load-with-filters")) {
        sendRequest(onSuccessLoad, onErrorLoad, true, true);
      } else {
        sendRequest(onSuccessLoad, onErrorLoad, true);
      }
    };
    var onTogglePageClick = function onTogglePageClick(evt, urlRequest) {
      var button = null;
      if (evt) {
        evt.preventDefault();
        button = evt.currentTarget;
      }
      if (!urlRequest && button) {
        url = button.getAttribute("href") || button.getAttribute("data-href");
      } else {
        url = urlRequest;
      }
      sendRequest(onSuccessToggle, onErrorLoad, true);
    };
    var onSortingBtnClick = function onSortingBtnClick(evt, urlRequest) {
      evt.preventDefault();
      var button = evt.currentTarget;
      button.classList.toggle("js-toggle-active");
      /* ??? */
      if (!urlRequest && button) {
        url = button.getAttribute("data-href") || button.getAttribute("href");
      } else {
        url = urlRequest;
      }
    };

    /**
     * Обновляем слайдер
     * @param {HTMLElement} el селектор слайдера
     */
    var updSlider = function updSlider(slider, slides) {
      Swiper.initedSliders[slider.dataset.sliderName].removeAllSlides();
      Swiper.initedSliders[slider.dataset.sliderName].appendSlide(slides);
      Swiper.initedSliders[slider.dataset.sliderName].update();
      Swiper.initedSliders[slider.dataset.sliderName].slideTo(0);
    };
    if (loadTrigger) {
      loadTrigger.addEventListener("click", onLoadTriggerClick);
      if (section.classList.contains("js-load-section--immediately")) {
        onLoadImmediately();
      }
    }
    if (pagination) {
      var paginationLinks = section.querySelectorAll(".js-pagination-link");
      if (paginationLinks.length > 0) {
        Array.prototype.forEach.call(paginationLinks, function (paginationLink) {
          if (paginationLink.hasAttribute("href")) {
            paginationLink.addEventListener("click", onTogglePageClick);
          }
        });
      }
    }
    if (sorting) {
      var sortingButtons = section.querySelectorAll(".js-sorting-btn");
      if (sortingButtons.length > 0) {
        Array.prototype.forEach.call(sortingButtons, function (sortingBtn) {
          if (sortingBtn.hasAttribute("data-href")) {
            sortingBtn.addEventListener("click", onSortingBtnClick);
          }
        });
      }
    }
    if (filters && !filtersInited) {
      filtersInited = true;
      itsoftApp.modules.filters.init(section, onTogglePageClick);
    }
  };
  module.initLoad = initLoad;
});
"use strict";

itsoftApp.createModule("loadItemsWithFilters", function () {
  var module = this;
  var initLoad = function initLoad(section) {
    var filters = section.querySelector(".js-filters"); //
    var sorting = section.querySelector(".js-sorting"); //
    var loadTarget = section.querySelector(".js-load-target");
    var loadTrigger = section.querySelector(".js-load");
    var loadTriggerParent;
    var url;
    var filtersInited = false; //

    if (loadTrigger) {
      loadTriggerParent = section.querySelector(".js-load-parent") || loadTrigger.parentNode;
    }
    var pagination = section.querySelector(".js-pagination"); ///
    var paginationParent;
    if (pagination) {
      paginationParent = pagination.parentNode; ///
    }

    var sendRequest = function sendRequest(onSuccess, onError, flag, withFilters) {
      var xhr = new XMLHttpRequest();
      xhr.addEventListener("load", function () {
        if (xhr.status === 200 && onSuccess) {
          if (flag) {
            onSuccess(xhr.response, flag);
          }
        } else {
          onError(xhr.response);
        }
      });
      xhr.addEventListener("error", function () {
        onError("Произошла ошибка соединения");
      });
      xhr.addEventListener("timeout", function () {
        onError("Запрос не успел выполниться за " + xhr.timeout + "мс");
      });
      xhr.timeout = 10000;
      if (withFilters) {
        DEBUG && console.log('YES, with filters');
        /* Повторяется из модуля filters */
        var filtersSection = section;
        var filtersForm = filtersSection.querySelector(".js-filters");
        var exIds = filtersForm.querySelector("[name='ex_ids']");
        var filtersBlocks = filtersSection.querySelectorAll(".js-filter-block");
        var allFiltersValues = [];
        allFiltersValues = Array.prototype.map.call(filtersBlocks, function (filterBlock) {
          var allFiltersItems = filterBlock.querySelectorAll(".js-filter-item") || [];
          var allCheckedFilters = Array.prototype.filter.call(allFiltersItems, function (item) {
            return item.checked;
          }) || [];
          return {
            name: filterBlock.getAttribute("name") || filterBlock.getAttribute("data-name") || allCheckedFilters[0].name,
            value: Array.prototype.map.call(allCheckedFilters, function (checkedFilter) {
              return checkedFilter.value;
            })
          };
        });
        url += "?";
        Array.prototype.forEach.call(allFiltersValues, function (filterValue, index, arr) {
          var selectName = filterValue.name;
          var selectValue = filterValue.value.join(';');
          url += selectName + "=" + selectValue;
          if (index < arr.length - 1) {
            url += '&';
          }
        });
        if (exIds) {
          url += '&';
          url += exIds.name + "=" + exIds.value;
        }
        url.replace(/\s/g, '+');
      }

      /* */

      xhr.open("GET", url);
      xhr.send();
    };
    var onErrorLoad = function onErrorLoad(data) {
      console.log("error ", data);
    };
    var removeOldDataFromPage = function removeOldDataFromPage() {
      var cards = loadTarget.querySelectorAll(".js-load-item");
      for (var i = 0; i < cards.length; i++) {
        cards[i].parentNode.removeChild(cards[i]);
      }
    };
    var removeOldNavFromPage = function removeOldNavFromPage() {
      pagination = section.querySelector(".js-pagination");
      if (pagination) {
        paginationParent.removeChild(pagination);
      }
    };
    var addNewDataToPage = function addNewDataToPage(wrapper) {
      var newElements = wrapper.querySelectorAll(".js-load-item"); //  Ищем элементы

      if (newElements.length > 0) {
        var fragment = document.createDocumentFragment();

        /*** ***/
        var isAccordion = wrapper.querySelector(".js-accordion");
        if (isAccordion) {
          new itsoftApp.modules.accordion.callback(isAccordion);
        }

        /*** ***/

        Array.prototype.forEach.call(newElements, function (newElement) {
          fragment.appendChild(newElement);
        });
        loadTarget.appendChild(fragment);
      }
    };
    var addNewNavToPage = function addNewNavToPage(wrapper) {
      var newPagination = wrapper.querySelector(".js-pagination"); //  Ищем навигацию
      var newLoadTrigger = wrapper.querySelector(".js-load"); // Ищем кнопку для загрузки доп. элементов

      if (newPagination) {
        var newPaginationLinks = newPagination.querySelectorAll(".js-pagination-link");
        if (newPaginationLinks.length > 0) {
          Array.prototype.forEach.call(newPaginationLinks, function (newPaginationLink) {
            if (newPaginationLink.hasAttribute("href")) {
              newPaginationLink.addEventListener("click", onTogglePageClick);
            }
          });
        }
        paginationParent.appendChild(newPagination);
      }
      if (newLoadTrigger && loadTriggerParent) {
        if (loadTriggerParent.classList.contains("g-hidden")) {
          loadTriggerParent.classList.remove("g-hidden");
        }
        loadTrigger.href = newLoadTrigger.href;
      } else {
        if (loadTriggerParent) {
          loadTriggerParent.classList.add("g-hidden");
        } else {
          /* TODO: сделать возможность добавления кнопки, если изначально её не было */
        }
      }
    };
    var onSuccessToggle = function onSuccessToggle(data, scrolling) {
      var wrapper = document.createElement("div");
      wrapper.innerHTML = data;
      removeOldDataFromPage();
      removeOldNavFromPage();
      addNewDataToPage(wrapper);
      addNewNavToPage(wrapper);

      // if (scrolling) {
      //     itsoftApp.modules.animateScroll.callback(loadTarget, null, 500, 500, "easeInOutQuad", 15);
      // }
    };

    var onSuccessLoad = function onSuccessLoad(data) {
      var wrapper = document.createElement("div");
      wrapper.innerHTML = data;
      removeOldNavFromPage();
      addNewDataToPage(wrapper);
      addNewNavToPage(wrapper);
    };
    var onLoadTriggerClick = function onLoadTriggerClick(evt) {
      evt.preventDefault();
      var button = evt.currentTarget;
      url = button.getAttribute("href");
      if (loadTrigger.classList.contains("js-load-with-filters")) {
        sendRequest(onSuccessLoad, onErrorLoad, true, true);
      } else {
        sendRequest(onSuccessLoad, onErrorLoad, true);
      }
    };
    var onTogglePageClick = function onTogglePageClick(evt, urlRequest) {
      var button = null;
      if (evt) {
        evt.preventDefault();
        button = evt.currentTarget;
      }
      if (!urlRequest && button) {
        url = button.getAttribute("href") || button.getAttribute("data-href");
      } else {
        url = urlRequest;
      }
      sendRequest(onSuccessToggle, onErrorLoad, true);
    };
    var onSortingBtnClick = function onSortingBtnClick(evt, urlRequest) {
      evt.preventDefault();
      var button = evt.currentTarget;
      button.classList.toggle("js-toggle-active");
      /* ??? */
      if (!urlRequest && button) {
        url = button.getAttribute("data-href");
      } else {
        url = urlRequest;
      }
    };
    if (loadTrigger) {
      loadTrigger.addEventListener("click", onLoadTriggerClick);
    }
    if (pagination) {
      var paginationLinks = section.querySelectorAll(".js-pagination-link");
      if (paginationLinks.length > 0) {
        Array.prototype.forEach.call(paginationLinks, function (paginationLink) {
          if (paginationLink.hasAttribute("href")) {
            paginationLink.addEventListener("click", onTogglePageClick);
          }
        });
      }
    }
    if (sorting) {
      var sortingButtons = section.querySelectorAll(".js-sorting-btn");
      if (sortingButtons.length > 0) {
        Array.prototype.forEach.call(sortingButtons, function (sortingBtn) {
          if (sortingBtn.hasAttribute("data-href")) {
            sortingBtn.addEventListener("click", onSortingBtnClick);
          }
        });
      }
    }
    if (filters && !filtersInited) {
      filtersInited = true;
      itsoftApp.modules.filters.init(section, onTogglePageClick);
    }
  };
  module.initLoad = initLoad;
});
"use strict";

/**
 * Мобильное меню
 *
 * NOTE: Модуль можно удалить, если на сайте предусмотрено
 * принципиально иное меню для мобильных устройств.
 */
itsoftApp.createModule("mobMenu", ["windowScroll"], function () {
  var module = this;
  var MobMenu = function MobMenu() {
    this.parentClass = "js-mobmenu";
    this.parent = document.querySelector("." + this.parentClass);
    this.toggleBtns = document.querySelector(".js-mobmenu-toggle");
    this.openedClass = "is-opened";
    this.activeClass = "is-active";
    this.opened = false;
    this.$body = itsoftApp.commonVars.$body;
    this.expandedBlocks = document.querySelector(".js-mobmenu-expand");
    this.fixedPageElems = document.querySelectorAll(".js-page-fixed-elem");
    this.getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;
    this.menuLinks = document.querySelectorAll(".js-link");
    if (!this.toggleBtns > 0) {
      return;
    }
    this.init();
  };
  MobMenu.prototype.openMenu = function () {
    if (this.opened) {
      return;
    }
    this.opened = true;
    if (this.fixedPageElems) {
      var scrollbarWidth = this.getScrollbarWidth();
      DEBUG && console.log("[module popups] scrollbarWidth: " + scrollbarWidth);
      Array.prototype.forEach.call(this.fixedPageElems, function (el) {
        el.style.paddingRight = scrollbarWidth + "px";
      });
    }
    this.toggleBtns.classList.add(this.activeClass);
    this.parent.classList.add(this.openedClass);
    document.documentElement.style.overflow = "hidden"; // NOTE: Отменил прокрутку
    DEBUG && console.log("[module mobMenu] menu opened");
  };
  MobMenu.prototype.closeMenu = function () {
    if (!this.opened) {
      return;
    }
    this.opened = false;
    if (this.fixedPageElems) {
      Array.prototype.forEach.call(this.fixedPageElems, function (el) {
        el.style.paddingRight = "0";
      });
    }
    document.documentElement.style.overflow = "visible"; // NOTE: Вернул прокрутку

    this.toggleBtns.classList.remove(this.activeClass);
    this.parent.classList.remove(this.openedClass);
    DEBUG && console.log("[module mobMenu] menu closed");
  };
  MobMenu.prototype.toggleBtnClick = function (evt) {
    var MOBMENU = this;
    evt.preventDefault();
    if (this.opened) {
      MOBMENU.closeMenu();
    } else {
      MOBMENU.openMenu();
    }
  };

  /**
   * Обработчик события пролистывания страницы.
   * Мы будем скрывать меню, если пользователь начал листать страницу вниз.
   *
   * @param  {number} y Текущее значение прокрутки страницы
   */
  MobMenu.prototype.scrollController = function (y) {
    var MOBMENU = this;
    if (!this.opened) {
      return;
    }
    // Значение уже придёт нам из модуля itsoftApp.modules.windowScroll,
    // но на всякий случай пропишем fallback.
    y = typeof y === "number" ? y : document.body.scrollTop || document.documentElement.scrollTop;
    var menuHeight = this.parent.offsetHeight + this.expandedBlocks.offsetHeight;

    // if (y > menuHeight + 20) {
    if (y + menuHeight > menuHeight + menuHeight / 3) {
      MOBMENU.closeMenu();
    }
  };

  /**
   * Как и в случае со всплывашками на сайте,
   * для меню, если мы видим оставшуюся часть страницы, и кликаем по затемнённой области,
   * то пользователь интуитивно ожидает, что меню закроется.
   * Данный обработчик как раз для этого.
   *
   * @param  {object} e Event
   */
  MobMenu.prototype.bodyClick = function (e) {
    var MOBMENU = this;
    if (!this.opened) {
      return;
    }
    var target = e.target;
    var hasParent = target.closest("." + this.parentClass);

    // Закрываем меню, только если клик произошёл
    // по элементу вне пределов родительского блока
    // (по сути - клик по любой точке экрана, кроме меню).
    if (!hasParent) {
      MOBMENU.closeMenu();

      // Отмена действия по умолчанию
      // (например, чтобы не произошёл переход по ссылке, если
      // мы кликнули по элементу <a>).
      return false;
    }
  };
  MobMenu.prototype.addListeners = function () {
    var MOBMENU = this;
    // Привязка событий и функций-обработчиков
    this.toggleBtns.addEventListener("click", MOBMENU.toggleBtnClick.bind(MOBMENU));
    this.$body.addEventListener("click", MOBMENU.bodyClick(MOBMENU));

    // NOTE: Выловили нелепый баг, на айпадике.
    // Без строчки ниже не срабатывало событие click у верхнего элемента body.
    // Говно, дерьмо, жопа :D
    itsoftApp.commonVars.$wrapper.addEventListener("click", function () {});
    Array.prototype.forEach.call(this.menuLinks, function (el) {
      el.addEventListener("click", function () {
        // if (currentOpenedPopup) {
        //     currentOpenedPopup.dispatchEvent(closeEvent);
        // }
        MOBMENU.closeMenu();
      });
    });
  };
  MobMenu.prototype.init = function () {
    if (!this.parent) {
      return false;
    }
    var MOBMENU = this;
    // Инициализируем слушатели событий
    this.addListeners();

    // Делегируем функцию в модуль windowScroll
    // (единая точка входа для события "scroll").
    DEBUG && console.log("%c--[module mobMenu] delegating scrollController to windowScroll module", "font-style: italic; color: #999");
    itsoftApp.modules.windowScroll.addEvent(MOBMENU.scrollController.bind(MOBMENU));
  };
  new MobMenu();
  module.callback = MobMenu;
});
"use strict";

/**
 * Общая точка входа
 * для события полной загрузки страницы
 * (включая загрузку изображений, метрик и прочего).
 *
 * NOTE: Не путать с событием DOMContentLoaded
 * (оно же - $(document).ready(function() {...}) - в терминах jQuery).
 */
itsoftApp.createModule("pageLoad", function () {
  // Локальные переменные
  var module = this;
  var events = [];
  var singleFunctionFired = false;
  var timeoutInit = 120;
  var timeoutDelta = 80;
  var $window = itsoftApp.commonVars.$window;
  var flag = false;
  var body = document.body;

  /**
   * Функция, которая сработает лишь один раз,
   * и будет означать полную загрузку страницы.
   */
  var singleLoadFunction = function singleLoadFunction() {
    var readyState = document.readyState;
    var func, timeoutCurrent;
    if (readyState !== "complete" || singleFunctionFired || !events.length) {
      return false;
    }
    DEBUG && console.log("%c[module pageLoad] window load event fired, count of functions to init: " + events.length + ", timeout for first func: " + timeoutInit + ", timeout delta for other: " + timeoutDelta, "color: purple");
    while (events.length > 0) {
      // Взять первый элемент массива,
      // и передать его в переменную.
      func = events.shift();

      // Будем запускать наши отложенные функции
      // через определённые промежутки времени, друг за другом с некоторым промежутком.
      // Мы уже знаем, что это функции,
      // поэтому доп. проверка не требуется.
      timeoutCurrent = timeoutCurrent ? timeoutCurrent + timeoutDelta : timeoutInit;
      setTimeout(func, timeoutCurrent);
    }
    singleFunctionFired = true;
    if (!flag) {
      $window.removeEventListener("load", singleLoadFunction);
      flag = true;
      body.classList.add("js-loaded");
      if (body.hasAttribute("data-no-script")) {
        body.removeAttribute("data-no-script");
      }
    }
  };

  // Привязка собитий и функции-обработчика
  if (document.readyState === "complete") {
    singleLoadFunction();
  } else {
    $window.addEventListener("load", singleLoadFunction);
  }

  /**
   * Добавление переданной функции в очередь на выполнение,
   * либо немедленное исполнение функции, если страница уже полностью загружена.
   *
   * @param {function} func
   */
  var addEvent = function addEvent(func) {
    if (typeof func !== "function") {
      return;
    }

    // Если страница ещё не загружена полность, то добавляем в очередь
    if (!singleFunctionFired) {
      events.push(func);
      DEBUG && console.log("[module pageLoad] function added, count of functions to init now: " + events.length);

      // Если уже загружена, то просто вызываем переданную функцию
    } else {
      DEBUG && console.log("[module pageLoad] firing function immediately, because window load event already fired");
      func();
    }
  };

  // Доступ к фукциям
  // текущего модуля
  module.addEvent = addEvent;
});
"use strict";

/**
 * Всплывашки на сайте
 *
 * NOTE: Механизм, позволяющий отменить скролл для страницы, при открытой всплывашке,
 * достаточно хитрый, поэтому лучше изучить данный модуль, чтобы досконально понимать, как он работает
 */
itsoftApp.createModule("popups", function () {
  var module = this;
  module.$wrapper = document.querySelector(".l-wrapper");
  var popups = document.querySelectorAll("." + "popup"); // this.popupClass

  if (!popups.length) {
    // TODO: Убрать или переделать, чтобы тесты прошли
    return false;
  }

  // Локальные переменные
  var $body = document.body;
  var $document = document.documentElement;
  // const activePopups = document.querySelectorAll("[data-bg-opened='true']");
  // const popupBox = document.querySelector("#popup-box");
  var fixedPageElems = document.querySelectorAll(".js-page-fixed-elem");
  var hasFixedElems = fixedPageElems.length > 0;
  var staticBackUrl = window.location.pathname;
  var dAttrAutohide = "data-autohide";
  var transitionEventEnd = itsoftApp.features.transitionEventEnd;
  // const disabledButtons = document.querySelectorAll(".js-disabled");
  var confirmation = document.querySelector(".js-confirmation");
  // const save = document.querySelector(".js-save");
  // const slider = {};
  // const hashedPopups = document.querySelectorAll("data-hash");
  window.currentOpenedPopup = undefined;
  var getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;
  var getScrTop = itsoftApp.utils.getScrTop;
  var currentSlide;
  var activeButton;
  // let pageHash;

  // if (hashedPopups.length > 0) {
  //     pageHash = location.hash;
  // }

  var Breakpoint = {
    mobile: 320,
    tablet: 768,
    desktop: 1280
  };
  var Popup = function Popup(popup) {
    if (!popup) {
      try {
        throw new Error("Не передан обязательный аргумент popup");
      } catch (err) {
        console.log(err);
      }
    }
    this.state = {
      closeButtonsAvailability: false,
      openButtonsAvailability: false,
      initedExemplar: false,
      opened: false
    };
    this.popup = popup;
    this.popupID = popup.id;
    this.openPopupBtnSelector = ".js-open-popup[data-popup-id='" + popup.id + "']";
    this.closePopupBtnSelector = ".js-close-popup[data-popup-id='" + popup.id + "']";
    this.openPopupBtns = document.querySelectorAll(this.openPopupBtnSelector);
    this.closePopupBtns = document.querySelectorAll(this.closePopupBtnSelector);
    this.lazyImages = [];
    this.popupClass = "popup";
    this.openedClass = "is-opened";
    this.dAttrSelector = "data-popup-selector";
    this.dAttrBgClose = "data-bg-close";
    this.hiddenClass = "g-hidden";
    this.evNameOpen = "popups:open";
    this.evNameClose = "popups:close";
    this.wrapperAbsClass = "is-abs";
    this.wrapperOverflow = "is-over";
    this.popupOpenedClass = "is-popup-opened";
    this.dAttrUrl = "data-url";
    this.dAttrHide = "data-hide";
    this.dAttrClose = "data-close-popup";
    this.hideDelayDefault = 3500;
    this.init();
  };
  Popup.prototype.globalState = {
    listenersAdded: false,
    historyPushed: false
  };
  Popup.prototype.openedPopups = [];
  Popup.prototype.autohidePopups = [].filter.call(popups, function (el) {
    return el.matches("[" + dAttrAutohide + "='true']");
  });
  Popup.prototype.lastOpenedPopup = null;
  Popup.prototype.detachEvents = function () {
    this.popup.removeEventListener(this.evNameOpen, this.popupOpen);
    this.popup.removeEventListener(this.evNameClose, this.popupClose);
    this.popup.removeEventListener("click", this.popupClick);
    Array.prototype.forEach.call(this.openPopupBtns, function (openBtn) {
      openBtn.removeEventListener("click", this.openPopupBtnClick);
    });
    Array.prototype.forEach.call(this.closePopupBtns, function (closeBtn) {
      closeBtn.removeEventListener("click", this.closePopupBtnClick);
    });
  };
  Popup.prototype.init = function () {
    var POPUP = this;
    POPUP.lazyImages = POPUP.popup.querySelectorAll(".lazyload-call");

    /**
     * Обработчик нажатий на кнопки клавиатуры.
     * Необходим для того, чтобы можно было закрыть всплывашку кнопкой ESC.
     *
     * NOTE: Так как возможны случаи, когда открыто несколько всплывах,
     * то закрываем их одна за одной, начиная с той, у которой наибольший z-index.
     *
     * @param  {object} e Event
     */
    Popup.prototype.keyController = function (evt) {
      // Обрабатываем только нажатие на ESC,
      // а все остальные нажатия игнорируем.
      if (evt.keyCode !== 27) {
        return;
      }
      if (!POPUP.openedPopups.length) {
        return;
      }
      var maxZI = 0;
      Array.prototype.forEach.call(POPUP.openedPopups, function (el) {
        var popup = el;
        var zi = parseInt(getComputedStyle(popup)["zIndex"], 10);
        if (isNaN(zi)) {
          zi = 0;
        }
        if (zi >= maxZI) {
          maxZI = zi;
          POPUP.lastOpenedPopup = popup;
        }
      });
      if (!POPUP.lastOpenedPopup) {
        return;
      }

      // Закрываем только последнюю открытую всплывашку
      if (!POPUP.lastOpenedPopup.hasAttribute("data-save")) {
        POPUP.lastOpenedPopup.dispatchEvent(window.closeEvent);
      }
    };
    if (!this.globalState.listenersAdded) {
      if (window.CustomEvent && typeof window.CustomEvent === "function") {
        window.closeEvent = new CustomEvent(this.evNameClose, {
          detail: {
            name: "Закрытие"
          }
        });
        window.openEvent = new CustomEvent(this.evNameOpen, {
          detail: {
            name: "Открытие"
          }
        });
      } else {
        window.closeEvent = document.createEvent("CustomEvent");
        window.openEvent = document.createEvent("CustomEvent");
        window.closeEvent.initCustomEvent(this.evNameClose, true, true, {
          name: "Закрытие"
        });
        window.openEvent.initCustomEvent(this.evNameOpen, true, true, {
          name: "Открытие"
        });
      }
      window.addEventListener("beforeunload", this.windowUnload);
      window.addEventListener("keyup", this.keyController);
      this.globalState.listenersAdded = true;
    }
    if (this.closePopupBtns.length > 0) {
      this.state.closeButtonsAvailability = true;
    }
    if (this.openPopupBtns.length > 0) {
      this.state.openButtonsAvailability = true;
    }

    /**
     * Клик по кнопкам, открывающим всплывахи.
     * Какую именно всплывашку открыть - обозначено в data- атрибуте.
     */
    Popup.prototype.openPopupBtnClick = function (evt) {
      evt.preventDefault();
      var self = this;
      var dataSlide = self.getAttribute("data-slide");
      // const selector = self.getAttribute(POPUP.dAttrSelector);

      dataSlide ? currentSlide = dataSlide : currentSlide = undefined;

      // if (selector) {
      // if (popup) {
      POPUP.popup.dispatchEvent(window.openEvent);
      // }
      // }

      // else {
      //     const popupType = self.getAttribute("data-popup-type")

      //     if (popupType = "image") {
      //         createImagePopup(self);
      //     } else {
      //         return;
      //     }
      // }
    };

    /**
     * Клик по кнопкам, закрывающим всплывашку.
     * Будет закрыта "родительская" всплывашка
     * (поиск по ближайшему родителю с нужным классом).
     */
    Popup.prototype.closePopupBtnClick = function () {
      var self = this;
      var checkbox = null;
      // const popup = self.closest("." + popupClass);
      var onBoxCheck = function onBoxCheck(evt) {
        if (evt.currentTarget.classList.contains("js-error")) {
          checkbox.classList.remove("js-error");
          checkbox.removeEventListener("change", onBoxCheck);
        }
      };
      if (this.classList.contains("js-save")) {
        if (self.hasAttribute("data-checkbox")) {
          var checkboxID = self.getAttribute("data-checkbox");
          checkbox = confirmation.querySelector(checkboxID);
          if (!checkbox.checked) {
            checkbox.classList.add("js-error");
            checkbox.addEventListener("change", onBoxCheck);
            return;
          }
        }
        itsoftApp.modules.cookie.setCookie(this);
      }
      POPUP.popup.dispatchEvent(window.closeEvent);
    };

    /**
     * Все действия, связанные с открытием всплывашки
     */
    Popup.prototype.popupOpen = function () {
      var self = this;
      if (self.classList.contains(POPUP.openedClass)) {
        return;
      }
      if (POPUP.lazyImages.length > 0) {
        if (!POPUP.lazyImages[0].getAttribute("data-ll-status")) {
          Array.prototype.forEach.call(POPUP.lazyImages, function (image) {
            LazyLoad.load(image, window.llCallRequestOptions);
          });
        }
      }

      // Если до этого уже были открыты всплывашки,
      // то вычисляем наибольший z-index, и присваиваем его
      // новой открывающейся всплывашке.
      // Иначе возможны ситуации, когда всплывашка открылась, но из-за расположения по вёрстке
      // оказалась ниже (за счет одинакового z-index), и в итоге её не видно.

      if (POPUP.openedPopups.length > 0) {
        var maxZI = 0;
        Array.prototype.forEach.call(POPUP.openedPopups, function (el) {
          var popup = el;
          if (popup.getAttribute("data-ignore") === "true") {
            return;
          }
          var zi = parseInt(getComputedStyle(popup)["zIndex"], 10);
          if (isNaN(zi)) {
            zi = 0;
          }
          maxZI = Math.max(maxZI, zi);
        });
        if (maxZI > 0) {
          self.style.zIndex = maxZI + 1;
          DEBUG && console.log("%c--[module popups] added z-index " + (maxZI + 1) + ", because there was another opened popups", "font-style: italic; color: #999");
        }
      }

      // Вычисляем текущую величину прокрутки страницы
      // (делаем это до того, как будут произведены какие-либо дальнейшие действия).
      var scrTop = getScrTop();
      DEBUG && console.log("[module popups] scrTop: " + scrTop);

      // Если есть fixed элементы на странице,
      // то задаём им padding-right, равный ширине полосы прокрутки.
      // Без этого такие элементы будут дёргаться,
      // так как в процессе открытия всплывашки слегка меняются общие стили страницы.
      if (hasFixedElems) {
        var scrollbarWidth = getScrollbarWidth();
        DEBUG && console.log("[module popups] scrollbarWidth: " + scrollbarWidth);
        Array.prototype.forEach.call(fixedPageElems, function (el) {
          el.style.paddingRight = scrollbarWidth + "px";
        });
      }

      // NOTE: Это из-за плашки browser-update,
      // которая задаёт <html> ненулевой margin-top,
      // (в случае, если плашка об устаревшем браузере показана)
      // из-за которого страница "прыгает".
      var mt = parseInt(getComputedStyle($document)["marginTop"], 10);
      var mtExists = !isNaN(mt) && mt !== 0;
      if (mtExists) {
        scrTop -= mt;
      }

      // Основная магия происходит здесь.
      // Элементу .l-wrapper задаётся класс, который одновременно
      // убирает полосу прокрутки у <body> (так как .l-wrapper теперь position: absolute),
      // и добавляет полосу прокрутки у самого .l-wrapper (за счёт overflow: auto).
      // После этого остаётся прокрутить элемент .l-wrapper до того же значения,
      // которое было до этого у <body> (мы посчитали эту величину ранее).
      // Происходит это достаточно быстро, чтобы пользователь ничего не заметил.
      if (module.$wrapper) {
        module.$wrapper.classList.add(POPUP.wrapperAbsClass);
        module.$wrapper.scrollTop = scrTop;
      }

      // NOTE: Это из-за плашки browser-update
      if (mtExists) {
        $document.scrollTop = 0;
      }

      // Это для отсутсвия скролла у <body> в некоторых редких случаях
      // (например, если висит плашка об устаревшем браузере)
      if (!POPUP.popup.hasAttribute("data-scroll")) {
        $body.classList.add(POPUP.popupOpenedClass);
      }

      // Здесь предусмотрена возможность автоматически скрывать некоторые всплывашки
      // при открытии других всплывашек.
      // Для этого им нужно задать определённый data- атрибут
      // (указан в локальных переменных в начале модуля).
      var autohidePopupsOpened = [].filter.call(POPUP.autohidePopups, function (el) {
        return el.classList.contains(POPUP.openedClass);
      });
      if (autohidePopupsOpened.length > 0) {
        DEBUG && console.log("[module popups] hided " + autohidePopupsOpened.length + " popups with " + dAttrAutohide + "=true");
        Array.prototype.forEach.call(autohidePopupsOpened, function (el) {
          el.classList.remove(POPUP.openedClass);
        });
      }
      if (window.currentOpenedPopup) {
        window.currentOpenedPopup = undefined;
      }

      // Далее, делаем нашу всплывашку видимой (за счёт класса)
      self.classList.add(POPUP.openedClass);
      window.currentOpenedPopup = self;
      POPUP.openedPopups.push(self);
      POPUP.state.opened = true;
      var isIncludeSlider = self.hasAttribute("data-slider");
      if (isIncludeSlider) {
        if (self.getAttribute("data-slider") !== "true") {
          var sliderContainer = self.closest(".js-slider");
          self.setAttribute("data-slider", "true");
          itsoftApp.modules.slidersLibrary.callback(sliderContainer, undefined, undefined, self.getAttribute("data-slider-name"), currentSlide);
        } else {
          itsoftApp.modules.slidersLibrary.slider[self.getAttribute("data-slider-name")].slideTo(+currentSlide);
        }
      }
      if (self.hasAttribute("data-destroy-device")) {
        if (!itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.viewWidth) {
          itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.viewWidth = true;
          itsoftApp.calculations.viewWidth = itsoftApp.utils.getViewportSize();
        }
        var onWindowResize = function onWindowResize() {
          if (itsoftApp.calculations.viewWidth >= Breakpoint[self.getAttribute("data-destroy-device")]) {
            self.dispatchEvent(window.closeEvent);
            window.removeEventListener("resize", onWindowResize);
            // todo: нужно попробовать реализовать через windowResize, с возможностью удалить из очереди по необходимости
          }
        };

        window.addEventListener("resize", onWindowResize);
      }

      // Здесь предусмотрена возможность
      // закрыть текущую всплывашку через определённый промежуток времени
      // (например, всплывашка с коротким информационным сообщением).
      // Для этого им нужно задать определённый data- атрибут
      // (указан в локальных переменных в начале модуля).
      var hideDelay = self.getAttribute(POPUP.dAttrHide);
      if (hideDelay) {
        hideDelay = parseInt(hideDelay, 10);
        hideDelay = isNaN(hideDelay) ? POPUP.hideDelayDefault : hideDelay;
        setTimeout(function () {
          self.dispatchEvent(window.closeEvent);
        }, hideDelay);
      }

      // При необходимости, можно управлять адресной строкой браузера
      var urlToChange = self.getAttribute(POPUP.dAttrUrl);
      if (urlToChange) {
        POPUP.changePageUrl(urlToChange);
      }
      DEBUG && console.log("[module popups] opened popup: " + (self.id ? "#" + self.id : "." + self.className));
    };

    /**
     * Все действия, связанные с закрытием всплывашки
     */
    Popup.prototype.popupClose = function () {
      var self = this;
      if (!POPUP.state.opened) {
        return;
      }
      if (activeButton) {
        /* ??? */
        activeButton.classList.remove("js-active");
        activeButton = undefined;
      } /* ??? */

      self.classList.remove(POPUP.openedClass);

      // Так как вплывашка прилетает не мгновенно, а плавно,
      // то сразу делать возврат страницы к исходному состоянию нельзя
      // (будут видны артефакты, сязанные с переводом полосы прокрутки
      // от body к .l-wrapper и обратно).
      var end = function end() {
        setTimeout(function () {
          POPUP.clearScrollStyles();
        }, 200);
        if (transitionEventEnd) {
          self.removeEventListener(transitionEventEnd, end);
          POPUP.openedPopups.pop();
        }
        POPUP.state.opened = false;
      };

      // Для современных браузеров, где работает свойство transition,
      // вешаем обработчик на событие transitionEnd.
      if (transitionEventEnd) {
        self.addEventListener(transitionEventEnd, end);

        // Для старых браузеров, сразу вызываем функцию.
      } else {
        end();
      }

      // При необходимости,
      // меняем (возвращаем обратно)
      // адрес в строке браузера.
      var urlToChange = self.getAttribute(POPUP.dAttrUrl);
      if (urlToChange) {
        POPUP.changePageUrl("back");
      }
      DEBUG && console.log("[module popups] closed popup: " + (self.id ? "#" + self.id : "." + self.className));
    };

    /**
     * Возврат страницы к исходному
     * (до того, как была открыта хоть одна всплывшка)
     * состоянию.
     *
     * @param  {boolean} force Часть функционала можно исполнить принудительно
     */
    Popup.prototype.clearScrollStyles = function (force) {
      if (force == null) {
        force = false;
      }

      // Функция выполнится, если не осталось открытых всплывашек
      // (потому что их может быть несколько, и закрытие одной не означает закрытие всех),
      // либо принудительно (в редких случаях).
      var hasOpenedPopups = POPUP.openedPopups.length > 0;
      if (hasOpenedPopups && !force) {
        return;
      }

      // Вычисляем текущую величину прокрутки страницы
      // (функция getScrTop достаточно "умная", чтобы посчитать текущий скролл при любом состоянии).
      // Это нужно сделать до того, как произойдут дальнейшие действия.
      // $wrapper.classList.add(wrapperOverflow);
      var scrTop = getScrTop();
      DEBUG && console.log("%c[module popups] (clearScrollStyles) scrTop: " + scrTop + ". force: " + force, "color: #999");
      // $wrapper.classList.remove(wrapperOverflow);
      // Возвращаем структурные элементы .l-wrapper и body
      // к исходному состоянию, убираем все необходимые классы.
      if (module.$wrapper) {
        module.$wrapper.classList.remove(POPUP.wrapperAbsClass);
      }
      $body.classList.remove(POPUP.popupOpenedClass);

      // Если на странице есть fixed элементы,
      // то убираем ранее заданное значение radding-right
      if (hasFixedElems) {
        Array.prototype.forEach.call(fixedPageElems, function (el) {
          el.style.paddingRight = "";
        });
      }

      // NOTE: Это из-за плашки browser-update
      var mt = parseInt(getComputedStyle($document)["marginTop"], 10);
      var mtExists = !isNaN(mt) && mt !== 0;
      if (mtExists) {
        scrTop += mt;
      }

      // Наконец, пролистываем body до того значения,
      // который был у .l-wrapper.
      // Происходит это довольно быстро, так что пользователь не заметит разницы.
      $document.scrollTop = scrTop;
    };

    /**
     * Обработчик события "click", который определяет,
     * по какому именно мы кликнули элементу, и, если это
     * "пустое пространство" за самой всплывахой,
     * то закрываем её.
     *
     * NOTE: Можно отменить данное действие, задав дополнительный data- атрибут
     *
     * @param  {object} e Event
     */
    Popup.prototype.popupClick = function (evt) {
      var self = this;
      if (evt.target === self && self.getAttribute(POPUP.dAttrBgClose) !== "false") {
        self.dispatchEvent(window.closeEvent);
      }
    };

    /**
     * Так как прокрутку страницы мы "отменяем" хитрым способом,
     * то при попытке перезагрузить страницу, на которой уже открыта всплывашка,
     * нас перекинет наверх страницы.
     * Это подбешивает, поэтому привязываем данную функцию на событие закрытия (обновления)
     * страницы. Мы принудительно возвращаем страницу к её исходному состоянию,
     * тем самым нас не перекинет наверх после перезагрузки.
     */
    Popup.prototype.windowUnload = function () {
      POPUP.clearScrollStyles(true);
    };
    this.popup.addEventListener(POPUP.evNameOpen, POPUP.popupOpen);
    this.popup.addEventListener(POPUP.evNameClose, POPUP.popupClose);
    this.popup.addEventListener("click", POPUP.popupClick);
    Array.prototype.forEach.call(this.openPopupBtns, function (openBtn) {
      openBtn.addEventListener("click", POPUP.openPopupBtnClick);
    });
    Array.prototype.forEach.call(this.closePopupBtns, function (closeBtn) {
      closeBtn.addEventListener("click", POPUP.closePopupBtnClick);
    });
    if (this.popup.getAttribute("data-bg-opened") == "true") {
      var dAttrSave = this.popup.getAttribute("data-save");
      if (dAttrSave && !itsoftApp.modules.cookie.getCookie(this.popup)) {
        this.popup.dispatchEvent(window.openEvent);
        DEBUG && console.log("data-bg open event");
      } else if (!dAttrSave) {
        this.popup.dispatchEvent(window.openEvent);
        DEBUG && console.log("data-bg else open event");
      } else {
        this.popup.dispatchEvent(window.closeEvent);
      }
    }
    if (!this.state.initedExemplar) {
      this.state.initedExemplar = true;
    }
  };
  // Перемещаем все всплывашки в конец <body>.
  // Это нужно для того, чтобы при открытии всплывашки,
  // событие "scroll" всплывало до <body> и <html>,
  // но НЕ всплывало до <div class="l-wrapper">.
  // Это важно, так как при открытии всплывашки прокрутка
  // убирается у <body> и появляется у <div class="l-wrapper">.
  // Тем самым, мы "отменяем скролл".
  //
  // NOTE: На самом деле, отменить стандартный скролл браузера нельзя
  // (иначе не было бы всей этой истории).
  // Можно отменить, например, всплытие события "click" или действие по умолчанию для него.
  // Но ряд событий отменить или прервать всплытие нельзя.

  /**
   * Изменение адресной строки браузера при открытии всплывашки
   * (по необходимости).
   * Доп. инфа:
   * http://stackoverflow.com/questions/824349/modify-the-url-without-reloading-the-page
   *
   * @param  {string} url     Новый адрес
   * @param  {string} popupID Необходимо для отработки случая, когда мы перешли на страницу по прямому адресу
   */
  Popup.prototype.changePageUrl = function (url) {
    // Если браузер не поддерживает работу с историей,
    // то прерываем выполнение функции.
    if (!window.history || typeof window.history.pushState !== "function" || typeof url !== "string") {
      DEBUG && console.log("%c[module popups] !window.history || typeof window.history.pushState != function || typeof url != string", "color: red");
      return;
    }

    // Переход "вперёд" по истории браузера ...
    if (url !== "back") {
      DEBUG && console.log("%c[module popups] trying to change page url to: " + url, "font-style: italic");
      window.history.pushState(false, false, url);
      this.globalState.historyPushed = true;

      // ... переход "назад"
    } else {
      // Случай, когда мы до этого открыли всплывашку и перешли "вперёд"
      if (this.globalState.historyPushed) {
        DEBUG && console.log("%c[module popups] trying to go back in history", "font-style: italic");
        window.history.back();

        // Случай, когда до этого не было перехода "вперёд"
        // (например, пользователь перешёл по прямой ссылке).
      } else if (typeof this.popupID === "string") {
        var urlToChange = staticBackUrl;
        urlToChange = staticBackUrl.substring(0, staticBackUrl.length - this.popupID.length - 1);
        DEBUG && console.log("%c[module popups] replacing page url to " + urlToChange, "font-style: italic; color: orange");
        window.history.replaceState(false, false, urlToChange);
      }
    }
  };
  Array.prototype.forEach.call(popups, function (popup) {
    new Popup(popup);
  });
  module.callback = {
    popup: Popup
  };
});
"use strict";

itsoftApp.createModule("saveCookies", ["disclaimer", "cookie"], function () {
  var saveCookieButtons = document.querySelectorAll(".js-save-button");
  var cookies = document.querySelector(".js-cookies");
  // const bodyEnd = document.querySelector(".js-padding-bottom");
  var disclaimer = document.querySelector(".js-disclaimer");
  window.cookiesState = "inactive";
  var saveCookie = function saveCookie(evt) {
    evt.preventDefault();
    var button = evt.currentTarget;
    if (button.hasAttribute("data-close")) {
      var plate = button.closest("[data-plate=" + button.getAttribute("data-close") + "]");
      plate && plate.classList.add("is-hidden");
    }
    itsoftApp.modules.cookie.setCookie(button);
    window.cookiesState = "inactive";
    // bodyEnd.style.paddingBottom = 0;
    disclaimer.style.transform = "translateY(".concat(0, "px)");
  };
  if (cookies && saveCookieButtons.length > 0) {
    window.cookiesState = "active";
    if (!itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.cookieHeight) {
      itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.cookieHeight = true;
      itsoftApp.calculations.cookieHeight = itsoftApp.utils.getCookieHeight();
    }
    // bodyEnd.style.paddingBottom = itsoftApp.calculations.cookieHeight + "px";

    Array.prototype.forEach.call(saveCookieButtons, function (button) {
      button.addEventListener("click", saveCookie);
    });
  } else if (disclaimer) {
    disclaimer.style.transform = "translateY(".concat(0, "px)");
  }
});
"use strict";

itsoftApp.createModule("scrollActions", ["startLoad"], function () {
  var module = this;
  var registeredPlugin = false;
  var registeredScrollTriggerPlugin = false;
  var getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;
  var initScrollActions = function initScrollActions(element, scrollTriggerFlag, cb, swiper) {
    var initScrollExemplar = function initScrollExemplar() {
      if (!itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.headerHeight) {
        itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.headerHeight = true;
        itsoftApp.calculations.headerHeight = itsoftApp.utils.getHeaderHeight();
      }
      var headerHeight = itsoftApp.calculations.headerFixedHeight;
      if (cb && typeof cb === "function") {
        cb();
      } else {
        if (element.classList.contains("js-hash-nav")) {
          var setActive = function setActive(link, index) {
            links.forEach(function (el) {
              return el.classList.remove("js-active");
            });
            mm.add("(max-width: 1023px)", function () {
              if (Swiper) {
                Swiper.initedSliders["tabsButtons"].slideTo(index);
              }
            });
            link.classList.add("js-active");
          };
          var mm = gsap.matchMedia();
          var links = gsap.utils.toArray("[data-color]");
          links.forEach(function (a, index) {
            var element = document.querySelector(a.getAttribute("href"));
            mm.add("(max-width: 1023px)", function () {
              ScrollTrigger.create({
                trigger: element,
                start: "top top+=" + (headerHeight + 20 + 66),
                // если высота шапки поменяется, возможно, придётся отредактировать
                end: "bottom top+=" + (headerHeight + 20 + 66),
                onToggle: function onToggle(self) {
                  return self.isActive && setActive(a, index);
                }
                // markers: true
              });
            });

            mm.add("(min-width: 1024px)", function () {
              ScrollTrigger.create({
                trigger: element,
                start: "top top+=" + (headerHeight + 20),
                // если высота шапки поменяется, возможно, придётся отредактировать
                end: "bottom top+=" + (headerHeight + 20),
                onToggle: function onToggle(self) {
                  return self.isActive && setActive(a, index);
                }
                // markers: true
              });
            });
          });
        } else if (element.classList.contains("js-batch")) {
          var steps = element.querySelectorAll(".js-step");
          if (element.classList.contains("js-effect")) {
            var picture = document.querySelector(".js-effect-picture");
            steps.forEach(function (step) {
              gsap.set(step, {
                autoAlpha: 0,
                yPercent: 15
              });
            });
            ScrollTrigger.batch(steps, {
              start: "top 70%",
              onEnter: function onEnter(batch) {
                return gsap.to(batch, {
                  autoAlpha: 1,
                  yPercent: 0,
                  stagger: 0.2,
                  duration: 2,
                  ease: "0.61, 0.1, 0.38, 0.8"
                });
              },
              ease: "0.61, 0.1, 0.38, 0.8"
              // markers: true
            });

            if (picture) {
              picture.classList.add("js-active");
            }
          } else if (element.classList.contains("js-problem")) {
            var _picture = document.querySelector(".js-effect-picture");
            var steps2 = element.querySelectorAll(".js-bacteria-step");
            steps.forEach(function (step) {
              gsap.set(step, {
                autoAlpha: 0,
                yPercent: 100
              });
            });
            steps2.forEach(function (step) {
              gsap.set(step, {
                autoAlpha: 0,
                xPercent: -45
              });
            });
            ScrollTrigger.batch(steps, {
              start: "top 70%",
              onEnter: function onEnter(batch) {
                return gsap.to(batch, {
                  autoAlpha: 1,
                  yPercent: 0,
                  stagger: 0.4,
                  duration: 2,
                  ease: "0.61, 0.1, 0.38, 0.8"
                });
              },
              ease: "0.61, 0.1, 0.38, 0.8"
              // markers: true
            });

            ScrollTrigger.batch(steps2, {
              start: "top 70%",
              onEnter: function onEnter(batch) {
                return gsap.to(batch, {
                  autoAlpha: 1,
                  xPercent: 0,
                  stagger: 0.1,
                  duration: 2,
                  ease: "0.61, 0.1, 0.38, 0.8"
                });
              },
              ease: "0.61, 0.1, 0.38, 0.8"
              // markers: true
            });

            if (_picture) {
              _picture.classList.add("js-active");
            }
          } else {
            var timelineScale = document.querySelector(".js-timeline-scale");
            steps.forEach(function (step) {
              gsap.set(step, {
                autoAlpha: 0,
                yPercent: 15
              });
            });
            ScrollTrigger.batch(steps, {
              start: "top 70%",
              onEnter: function onEnter(batch) {
                return gsap.to(batch, {
                  autoAlpha: 1,
                  yPercent: 0,
                  stagger: 0.3,
                  duration: 2,
                  ease: "0.68, 0.13, 0.42, 1.01"
                });
              },
              ease: "0.68, 0.13, 0.42, 1.01"
              // markers: true
            });

            if (timelineScale) {
              timelineScale.classList.add("js-active");
            }
          }
        }
      }
    };
    new itsoftApp.modules.startLoad.callback(initScrollExemplar, itsoftApp.libraries.scrollTrigger);
  };
  module.callback = initScrollActions;
});
"use strict";

itsoftApp.createModule("scrollTo", ["windowResize", "startLoad"], function () {
  var module = this;
  var sideNav = document.querySelector(".sticky-layout__left");
  var ResponsiveScroll = function ResponsiveScroll() {
    this.duration = 2;
    this.init();
  };
  var getSidenavHeight = function getSidenavHeight() {
    var sideNavHeight = sideNav ? sideNav.offsetHeight : 0;
    return sideNavHeight;
  };
  ResponsiveScroll.prototype.scrollTo = function (hash) {
    var RESPONSIVE_SCROLL = this;
    var mm = gsap.matchMedia();
    mm.add("(min-width: 1024px)", function () {
      gsap.to(window, {
        duration: RESPONSIVE_SCROLL.duration,
        scrollTo: {
          y: hash,
          offsetY: itsoftApp.calculations.headerFixedHeight
        }
      });
    });
    mm.add("(max-width: 1023px)", function () {
      gsap.to(window, {
        duration: RESPONSIVE_SCROLL.duration,
        scrollTo: {
          y: hash,
          offsetY: itsoftApp.calculations.headerFixedHeight + getSidenavHeight()
        }
      });
    });
  };
  ResponsiveScroll.prototype.onLinkClick = function (evt) {
    evt.preventDefault();
    var RESPONSIVE_SCROLL = this;
    var target = evt.currentTarget;
    var hash = target.getAttribute("href");
    if (!itsoftApp.libraries.scrollToPlugin.loaded) {
      new itsoftApp.modules.startLoad.callback(function () {
        RESPONSIVE_SCROLL.scrollTo(hash);
      }, itsoftApp.libraries.scrollToPlugin);
    } else {
      RESPONSIVE_SCROLL.scrollTo(hash);
    }
  };
  ResponsiveScroll.prototype.init = function () {
    var RESPONSIVE_SCROLL = this;
    if (itsoftApp.state.hashActive) {
      new itsoftApp.modules.startLoad.callback(function () {
        RESPONSIVE_SCROLL.scrollTo(itsoftApp.state.hash);
      }, itsoftApp.libraries.scrollToPlugin);
    }
    var links = document.querySelectorAll("a[href^='#']:not([href='#'])");

    /* Проходимся по всем элементам, у которых в href есть хэш */
    Array.prototype.forEach.call(links, function (link) {
      link.addEventListener("click", RESPONSIVE_SCROLL.onLinkClick.bind(RESPONSIVE_SCROLL));
    });
  };
  itsoftApp.modules.pageLoad.addEvent(function () {
    new ResponsiveScroll();
  });
  module.callback = ResponsiveScroll;
});
"use strict";

itsoftApp.createModule("slidersLibrary", function () {
  var module = this;
  var Slider = function Slider(el, sliderSettings, cb, currentSlide) {
    this.el = el;
    this.sliderSettings = sliderSettings;
    this.currentSlide = currentSlide;
    this.sliderContainer = el.querySelector(".swiper-container");
    this.navigation = el.querySelector(".swiper-navigation");
    this.pagination = el.querySelector(".swiper-pagination");
    this.scrollbar = el.querySelector(".swiper-scrollbar");
    this.dataDevice = el.getAttribute("data-destroy-device");
    this.destroyDirection = el.getAttribute("data-destroy-direction");
    this.withoutNavigation = el.hasAttribute("data-without-navigation");
    this.withoutPagination = el.hasAttribute("data-without-pagination");
    this.isInitialized = false;
    this.initializedSlider = null;
    this.cb = cb;
    this.init();
  };
  Slider.prototype.init = function () {
    var SLIDER = this;
    var outerNavName = SLIDER.sliderContainer.getAttribute("data-slider-name") || SLIDER.sliderSettings && SLIDER.sliderSettings.sliderName || "";
    SLIDER.outerNavigation = document.querySelector("[data-slider-nav='" + outerNavName + "']");
    Slider.prototype.onWindowResize = function () {
      var SLIDER = this;
      if (SLIDER.destroyDirection === "from" && SLIDER.dataDevice && itsoftApp.utils.getViewportSize() >= +SLIDER.dataDevice) {
        if (SLIDER.isInitialized === true) {
          SLIDER.destroySlider();
        }
      } else if (SLIDER.destroyDirection === "to" && SLIDER.dataDevice && itsoftApp.utils.getViewportSize() <= +SLIDER.dataDevice) {
        if (SLIDER.isInitialized === true) {
          SLIDER.destroySlider();
        }
      } else {
        if (SLIDER.isInitialized === false) {
          SLIDER.initSlider();
          DEBUG && console.log("init", ' ' + outerNavName);
        }
      }
    };
    Slider.prototype.createSlider = function () {
      if (!SLIDER.sliderSettings) {
        return;
      }
      if (!SLIDER.withoutNavigation && (SLIDER.navigation || SLIDER.outerNavigation)) {
        var prevBtn = SLIDER.navigation && SLIDER.navigation.querySelector(".js-prev-btn") || SLIDER.outerNavigation && SLIDER.outerNavigation.querySelector(".js-prev-btn");
        var nextBtn = SLIDER.navigation && SLIDER.navigation.querySelector(".js-next-btn") || SLIDER.outerNavigation && SLIDER.outerNavigation.querySelector(".js-next-btn");
        SLIDER.sliderSettings.navigation = {};
        SLIDER.sliderSettings.navigation.prevEl = prevBtn;
        SLIDER.sliderSettings.navigation.nextEl = nextBtn;
      }
      if (!SLIDER.withoutPagination && SLIDER.pagination) {
        if (!SLIDER.sliderSettings.pagination) {
          SLIDER.sliderSettings.pagination = {};
        }
        SLIDER.sliderSettings.pagination.el = SLIDER.pagination;
        if (SLIDER.pagination.classList.contains("js-pagination-dots")) {
          SLIDER.sliderSettings.pagination.type = "bullets";
          SLIDER.sliderSettings.pagination.clickable = true;
        } else if (SLIDER.pagination.classList.contains("js-pagination-progress")) {
          SLIDER.sliderSettings.pagination.type = "progressbar";
          // SLIDER.sliderSettings.pagination.clickable = true;
        } else {
          SLIDER.sliderSettings.pagination.type = "fraction";
          SLIDER.sliderSettings.pagination.renderFraction = function (currentClass, totalClass) {
            return "<span class='" + currentClass + "'></span>" + "/" + "<span class='" + totalClass + "'></span>";
          };
        }
      }
      if (SLIDER.scrollbar) {
        var scrollbar = SLIDER.el.querySelector(".swiper-scrollbar");
        SLIDER.sliderSettings.scrollbar = {};
        SLIDER.sliderSettings.scrollbar.el = scrollbar;
        SLIDER.sliderSettings.scrollbar.draggable = true;
      }
      if (SLIDER.dataDevice) {
        SLIDER.onWindowResize.call(SLIDER);
        itsoftApp.modules.windowResize.addEvent(SLIDER.onWindowResize.bind(SLIDER)); // TODO: проверить this
      } else {
        SLIDER.initSlider();
      }
    };
    new itsoftApp.modules.startLoad.callback(this.createSlider, itsoftApp.libraries.slider);
  };
  Slider.prototype.destroySlider = function () {
    this.initializedSlider.destroy(false, true);
    this.initializedSlider = undefined;
    this.isInitialized = false;
  };
  Slider.prototype.initSlider = function () {
    this.initializedSlider = new Swiper(this.sliderContainer, this.sliderSettings);
    if (this.initializedSlider) {
      if (this.currentSlide) {
        this.initializedSlider.slideTo(+this.currentSlide);
      }
      this.isInitialized = true;
    }
  };
  module.callback = Slider;
});
"use strict";

/**
 * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
 * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
 * Таким образом можно управлять всеми конфигами в этом файле
 */
itsoftApp.createModule("slidersSettings", function () {
  // Локальные переменные
  var module = this;
  var signsDecor = document.querySelector(".js-signs-decor");
  module.initedSwipers = {};
  var Settings = {
    global: {
      slidesPerView: "auto",
      simulateTouch: false,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      followFinger: false,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      freeModeMomentum: false,
      speed: 500,
      on: {
        init: function init() {
          var swiper = this;
          var swiperContainer = swiper.el;
          var sliderTrigger = swiperContainer.closest("[data-lazy-function='slider']");
          var sliderName = swiperContainer.getAttribute("data-slider-name") || "global";
          if (!module.initedSwipers.hasOwnProperty(sliderName)) {
            module.initedSwipers[sliderName] = swiper;
          }
          swiper.params.custom = {
            swiperContainer: swiperContainer,
            sliderTrigger: sliderTrigger,
            sliderName: sliderName
          };
        }
      },
      breakpoints: {
        1024: {
          slidesPerView: 3
        }
      }
    },
    banners: {
      slidesPerView: 1,
      spaceBetween: 12,
      simulateTouch: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      followFinger: true,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      freeModeMomentum: false,
      speed: 500,
      autoHeight: true,
      on: {
        init: function init() {
          var swiper = this;
          var swiperContainer = swiper.el;
          var sliderTrigger = swiperContainer.closest("[data-lazy-function='slider']");
          var sliderName = swiperContainer.getAttribute("data-slider-name") || "banners";
          if (!module.initedSwipers.hasOwnProperty(sliderName)) {
            module.initedSwipers[sliderName] = swiper;
          }
          swiper.params.custom = {
            swiperContainer: swiperContainer,
            sliderTrigger: sliderTrigger,
            sliderName: sliderName
          };
        }
      },
      breakpoints: {
        1024: {
          spaceBetween: 24
        }
      }
    },
    signs: {
      slidesPerView: 1,
      spaceBetween: 12,
      simulateTouch: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      // followFinger: true,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      freeModeMomentum: false,
      speed: 1600,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      on: {
        init: function init() {
          var swiper = this;
          var swiperContainer = swiper.el;
          var sliderTrigger = swiperContainer.closest("[data-lazy-function='slider']");
          var sliderName = swiperContainer.getAttribute("data-slider-name") || "signs";
          if (!module.initedSwipers.hasOwnProperty(sliderName)) {
            module.initedSwipers[sliderName] = swiper;
          }
          swiper.params.custom = {
            swiperContainer: swiperContainer,
            sliderTrigger: sliderTrigger,
            sliderName: sliderName
          };
        },
        slidePrevTransitionStart: function slidePrevTransitionStart() {
          var swiper = this;
          var description = swiper.slides[swiper.activeIndex + 1].querySelector(".js-signs-description");
          var prevDescription = swiper.slides[swiper.activeIndex].querySelector(".js-signs-description");
          description.style.opacity = 0;
          description.style.transform = "translateY(100%)";
          prevDescription.style.opacity = 1;
          prevDescription.style.transform = "translateY(0)";
          var angle = 90 * swiper.activeIndex;
          signsDecor.style.transform = "translate(-50%) rotate(".concat(angle, "deg)");
        },
        slideNextTransitionStart: function slideNextTransitionStart() {
          var swiper = this;
          var description = swiper.slides[swiper.activeIndex - 1].querySelector(".js-signs-description");
          var nextDescription = swiper.slides[swiper.activeIndex].querySelector(".js-signs-description");
          description.style.opacity = 0;
          description.style.transform = "translateY(-100%)";
          nextDescription.style.opacity = 1;
          nextDescription.style.transform = "translateY(0)";
          var angle = 90 * swiper.activeIndex;
          signsDecor.style.transform = "translate(-50%) rotate(".concat(angle, "deg)");
        }
      },
      breakpoints: {
        1024: {
          spaceBetween: 24
        }
      }
    },
    publications: {
      slidesPerView: 1.04,
      spaceBetween: 12,
      simulateTouch: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      followFinger: false,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      freeModeMomentum: false,
      speed: 500,
      on: {
        init: function init() {
          var swiper = this;
          var swiperContainer = swiper.el;
          var sliderTrigger = swiperContainer.closest("[data-lazy-function='slider']");
          var sliderName = swiperContainer.getAttribute("data-slider-name") || "publications";
          if (!module.initedSwipers.hasOwnProperty(sliderName)) {
            module.initedSwipers[sliderName] = swiper;
          }
          swiper.params.custom = {
            swiperContainer: swiperContainer,
            sliderTrigger: sliderTrigger,
            sliderName: sliderName
          };
        }
      },
      breakpoints: {
        768: {
          slidesPerView: 2.1,
          spaceBetween: 16
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24
        }
      }
    },
    actionPictures: {
      slidesPerView: 1,
      simulateTouch: true,
      spaceBetween: 10,
      watchOverflow: true,
      followFinger: true,
      freeModeMomentum: false,
      speed: 500,
      effect: 'fade',
      mousewheel: {
        eventsTarget: "[data-multiple-slider]",
        enabled: true,
        sensitivity: 0,
        releaseOnEdges: true
      },
      fadeEffect: {
        crossFade: true
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      on: {
        init: function init() {
          var swiper = this;
          var swiperContainer = swiper.el;
          var sliderTrigger = swiperContainer.closest("[data-lazy-function='slider']");
          var sliderName = sliderTrigger.getAttribute("data-slider-1") || swiperContainer.getAttribute("data-slider-name") || "actionPictures";
          if (!module.initedSwipers.hasOwnProperty(sliderName)) {
            module.initedSwipers[sliderName] = swiper;
          }
          swiper.params.custom = {
            swiperContainer: swiperContainer,
            sliderTrigger: sliderTrigger,
            sliderName: sliderName
          };
          var multipleSliderContainer = sliderTrigger.closest("[data-multiple-slider]");
          var secondSliderTrigger = multipleSliderContainer && multipleSliderContainer.querySelector("[data-slider-2]");
          swiper.params.custom.secondSliderName = secondSliderTrigger && secondSliderTrigger.getAttribute("data-slider-2");
          var sliderSettingsKey = secondSliderTrigger && secondSliderTrigger.getAttribute("data-slider-settings"); // получаем data-атрибут
          var sliderSettingsObject = itsoftApp.modules.slidersSettings.getSettings(sliderSettingsKey); // получаем объект конфига

          if (sliderSettingsKey && sliderSettingsObject) {
            new itsoftApp.modules.slidersLibrary.callback(secondSliderTrigger, sliderSettingsObject);
          } else {
            new itsoftApp.modules.slidersLibrary.callback(secondSliderTrigger);
          }
        },
        slideChange: function slideChange() {
          // if (isSyncing) return; // Прерываем, если уже идёт синхронизация
          var swiper = this;
          var dependentInitedSlider2 = module.initedSwipers.hasOwnProperty(swiper.params.custom.secondSliderName) && module.initedSwipers[swiper.params.custom.secondSliderName];
          if (dependentInitedSlider2 && !dependentInitedSlider2.animating) {
            dependentInitedSlider2.slides.forEach(function (slide) {
              slide.classList.remove('js-active-slide');
            });
            var activeSlide = dependentInitedSlider2.slides[this.activeIndex];
            if (activeSlide) {
              activeSlide.classList.add('js-active-slide');
            }
            // dependentInitedSlider2.slideTo(this.activeIndex, false, false);
          }
        }
      }
    },

    actionTexts: {
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 12,
      speed: 500,
      simulateTouch: true,
      // followFinger: true,
      // allowTouchMove: true,
      watchOverflow: true,
      slideToClickedSlide: true,
      on: {
        init: function init() {
          var swiper = this;
          var swiperContainer = swiper.el;
          var sliderTrigger = swiperContainer.closest("[data-slider-2]");
          var sliderName = sliderTrigger.getAttribute("data-slider-2") || swiperContainer.getAttribute("data-slider-name") || "actionText";
          if (!module.initedSwipers.hasOwnProperty(sliderName)) {
            module.initedSwipers[sliderName] = swiper;
          }
          swiper.params.custom = {
            swiperContainer: swiperContainer,
            sliderTrigger: sliderTrigger,
            sliderName: sliderName
          };
          var multipleSliderContainer = sliderTrigger.closest("[data-multiple-slider]");
          var firstSliderTrigger = multipleSliderContainer && multipleSliderContainer.querySelector("[data-slider-1]");
          swiper.params.custom.mainSliderName = firstSliderTrigger && firstSliderTrigger.getAttribute("data-slider-1");
          module.initedSwipers[sliderName].controller.control = module.initedSwipers[swiper.params.custom.mainSliderName];
          module.initedSwipers[swiper.params.custom.mainSliderName].controller.control = module.initedSwipers[sliderName];
          swiper.slides[0].classList.add("js-active-slide");
          var mainSlider1 = module.initedSwipers.hasOwnProperty(swiper.params.custom.mainSliderName) && module.initedSwipers[swiper.params.custom.mainSliderName];

          // if (mainSlider1 && !mainSlider1.animating) {
          //     // mainSlider1.slideTo(this.activeIndex, false, false);
          // }

          var onSlideClick = function onSlideClick(index) {
            if (mainSlider1) {
              // && !mainSlider1.animating - ломает слайдер
              mainSlider1.slideTo(index, 500, true);
            }
          };
          swiper.slides.forEach(function (slide, index) {
            slide.addEventListener("click", function (evt) {
              evt.preventDefault();
              onSlideClick(index);
            });
          });
        },
        slideChange: function slideChange() {
          var swiper = this;
          var mainSlider1 = module.initedSwipers.hasOwnProperty(swiper.params.custom.mainSliderName) && module.initedSwipers[swiper.params.custom.mainSliderName];

          // if (mainSlider1 && !mainSlider1.animating) {
          //     mainSlider1.slideTo(this.activeIndex, false, false);
          // }
        }
      },

      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 16,
          direction: 'vertical'
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 39,
          direction: 'vertical'
        }
      }
    },
    tabsButtons: {
      simulateTouch: false,
      slideToClickedSlide: true,
      slidesPerView: "auto",
      followFinger: false,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      freeModeMomentum: false,
      speed: 500,
      on: {
        init: function init() {
          var swiper = this;
          var swiperContainer = swiper.el;
          var sliderName = swiperContainer.getAttribute("data-slider-name");
          if (sliderName) {
            Swiper.initedSliders[sliderName] = this;
          }
          var target = swiperContainer.closest(".js-scroll-trigger.js-hash-nav");
          if (target) {
            target.classList.add("js-visible");
            itsoftApp.modules.scrollActions.callback(target, true, false);
          }
        }
      }
    },
    brands: {
      slidesPerView: 2,
      spaceBetween: 8,
      simulateTouch: false,
      slidesPerColumn: 2,
      slidesPerColumnFill: 'row',
      slidesPerGroup: 2,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      followFinger: false,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      freeModeMomentum: false,
      speed: 500,
      on: {
        init: function init() {
          var swiper = this;
          var swiperContainer = swiper.el;
          var sliderTrigger = swiperContainer.closest("[data-lazy-function='slider']");
          var sliderName = swiperContainer.getAttribute("data-slider-name") || "global";
          if (!module.initedSwipers.hasOwnProperty(sliderName)) {
            module.initedSwipers[sliderName] = swiper;
          }
          swiper.params.custom = {
            swiperContainer: swiperContainer,
            sliderTrigger: sliderTrigger,
            sliderName: sliderName
          };
        }
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 16,
          slidesPerColumn: 1,
          slidesPerGroup: 1
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 28,
          slidesPerColumn: 1,
          slidesPerGroup: 1
        }
      }
    }
  };
  var getSettings = function getSettings(slidersSettingsKey) {
    return Settings[slidersSettingsKey];
  };
  module.getSettings = getSettings;
});
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
itsoftApp.createModule("social", function () {
  var module = this;

  /**
   * Ключ в localStorage, под которым храним айди статей, которые пользователь уже лайкнул.
   * Значение — простой объект-словарь вида { "3": true, "12": true }.
   * localStorage переживает перезагрузку страницы, закрытие вкладки и перезапуск браузера,
   * поэтому годится и для "новой сессии" из ТЗ.
   */
  var STORAGE_KEY = "helinorm:likedArticles";
  var getLikedArticles = function getLikedArticles() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return {};
      var parsed = JSON.parse(raw);
      return parsed && _typeof(parsed) === "object" && !Array.isArray(parsed) ? parsed : {};
    } catch (e) {
      /* localStorage может быть недоступен (private mode, ITP, политики и т.п.) —
         работаем без персистентности, не падаем. */
      return {};
    }
  };
  var saveLikedArticles = function saveLikedArticles(liked) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(liked));
    } catch (e) {
      /* нет доступа к localStorage — просто пропускаем запись */
    }
  };
  var isArticleLiked = function isArticleLiked(articleId) {
    if (!articleId) return false;
    return Boolean(getLikedArticles()[articleId]);
  };
  var setArticleLiked = function setArticleLiked(articleId, isLiked) {
    if (!articleId) return;
    var liked = getLikedArticles();
    if (isLiked) {
      liked[articleId] = true;
    } else {
      delete liked[articleId];
    }
    saveLikedArticles(liked);
  };

  /**
   * Резолвим идентификатор статьи. Бэкенд может отдать его в нескольких видах:
   *   - data-id="3"      (основной вариант, как сейчас в шаблоне)
   *   - id="3"           (если разметка сделана по-другому)
   *   - data-article-id  (на всякий случай — полезно для устойчивости к доработкам бэка)
   * Пустые строки и пробелы считаем "не задан". Возвращаем строку или null.
   *
   * Важно: отсутствие id — это намеренный сигнал бэкенда «эта статья
   * уже лайкнута пользователем, повторный запрос делать не нужно».
   * Кнопке в таком случае надо просто оставаться активной.
   */
  var resolveArticleId = function resolveArticleId(likeButton) {
    var candidates = [likeButton.getAttribute("data-id"), likeButton.getAttribute("data-article-id"), likeButton.getAttribute("id")];
    for (var i = 0; i < candidates.length; i++) {
      var raw = candidates[i];
      if (raw === null || raw === undefined) continue;
      var trimmed = String(raw).trim();
      if (trimmed === "" || trimmed === "0") continue;
      return trimmed;
    }
    return null;
  };

  /**
   * Внутри лайк-кнопки лежит <span class="button__text">{count}</span> (см. include/views/button-main.php).
   * Берём именно его — чтобы поправить только число и не зацепить иконку.
   */
  var getCountElement = function getCountElement(likeButton) {
    return likeButton.querySelector(".button__text");
  };

  /**
   * Все «зеркала» счётчика, которые держим в синхроне с кнопкой.
   * Сейчас это в первую очередь ярлычок с количеством лайков в шапке статьи —
   * <span class="card-publication__tag-text js-like-count" data-id="…">.
   *
   * Привязываем зеркало к статье через data-id, чтобы при нескольких статьях
   * на одной странице (карточки в подборках и т.п.) счётчики чужих статей
   * не перекинулись из-за нашего клика. Если у зеркала data-id не задан,
   * считаем его «общим» и обновляем безусловно.
   */
  var getMirrorCountElements = function getMirrorCountElements(articleId) {
    var all = document.querySelectorAll(".js-like-count");
    var matched = [];
    Array.prototype.forEach.call(all, function (el) {
      var mirrorId = el.getAttribute("data-id");
      if (!mirrorId || String(mirrorId).trim() === "") {
        matched.push(el);
      } else if (articleId && String(mirrorId).trim() === String(articleId)) {
        matched.push(el);
      }
    });
    return matched;
  };
  var NBSP = String.fromCharCode(0x00A0);
  var parseCount = function parseCount(text) {
    /* На бэке цифра может прийти отформатированной (пробелы-разделители тысяч,
       неразрывные пробелы), поэтому перед parseInt чистим всю пробельную окрошку. */
    var raw = (text || "0").split(NBSP).join("").replace(/\s+/g, "");
    var value = parseInt(raw, 10);
    return Number.isFinite(value) ? value : 0;
  };
  var readCount = function readCount(likeButton) {
    var countEl = getCountElement(likeButton);
    if (!countEl) return 0;
    return parseCount(countEl.textContent);
  };
  var writeCount = function writeCount(likeButton, value, articleId) {
    var safeValue = Math.max(0, value);
    var stringValue = String(safeValue);
    var countEl = getCountElement(likeButton);
    if (countEl) {
      countEl.textContent = stringValue;
    }

    /* Параллельно обновляем все зеркала (например, ярлычок с количеством лайков
       в шапке статьи), чтобы цифры везде совпадали. */
    var mirrors = getMirrorCountElements(articleId);
    Array.prototype.forEach.call(mirrors, function (mirror) {
      mirror.textContent = stringValue;
    });
  };
  var bumpLikeCount = function bumpLikeCount(likeButton, delta, articleId) {
    writeCount(likeButton, readCount(likeButton) + delta, articleId);
  };
  var init = function init() {
    var yaShareTrigger = document.querySelector(".ya-share-trigger");
    if (yaShareTrigger) {
      var yaShare = document.querySelector(".ya-share2");
      var scriptShr = document.createElement('script');
      scriptShr.setAttribute('src', 'https://yastatic.net/share2/share.js');
      scriptShr.setAttribute('async', '');
      itsoftApp.modules.pageLoad.addEvent(function () {
        setTimeout(function () {
          document.body.appendChild(scriptShr);
        }, 3000);
      });
    }
    var isJsonString = function isJsonString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    };
    var changeLikeCount = function changeLikeCount(response) {
      var parseResponse = null;
      if (isJsonString(response)) {
        parseResponse = JSON.parse(response);
      }
    };

    /**
     * sendRequest принимает onSuccess / onError, чтобы вызывающий код
     * мог менять UI только после реального ответа сервера.
     * Поддерживаем диапазон 2xx, не только строгое 200.
     */
    var sendRequest = function sendRequest(url, onSuccess, onError) {
      var xhr = new XMLHttpRequest();
      xhr.addEventListener("load", function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          changeLikeCount(xhr.response);
          if (typeof onSuccess === "function") {
            onSuccess(xhr.response);
          }
        } else {
          DEBUG && console.log(xhr.response, ' xhr.response ERROR');
          if (typeof onError === "function") {
            onError("Сервер вернул статус " + xhr.status);
          }
        }
      });
      xhr.addEventListener("error", function () {
        if (typeof onError === "function") {
          onError("Произошла ошибка соединения");
        } else {
          DEBUG && console.log("Произошла ошибка соединения");
        }
      });
      xhr.addEventListener("timeout", function () {
        if (typeof onError === "function") {
          onError("Запрос не успел выполниться за " + xhr.timeout + "мс");
        } else {
          DEBUG && console.log("Запрос не успел выполниться за " + xhr.timeout + "мс");
        }
      });
      xhr.timeout = 10000;
      xhr.open("GET", url);
      // xhr.open("POST", url);
      xhr.send();
    };

    /* На странице потенциально может быть больше одной лайк-кнопки
       (карточки в подборках и т.п.), поэтому пробегаемся по всем .js-like. */
    var likeButtons = document.querySelectorAll(".js-like");
    Array.prototype.forEach.call(likeButtons, function (likeButton) {
      /* Защита от повторной инициализации: модуль social вызывается через lazy-script
         (см. lazyLoading.js), и при некоторых сценариях init может прилететь повторно. */
      if (likeButton.dataset.likeBound === "true") {
        return;
      }
      likeButton.dataset.likeBound = "true";
      var action = likeButton.getAttribute("data-url");
      var articleId = resolveArticleId(likeButton);

      /* Кнопка считается «уже лайкнутой» в двух эквивалентных случаях:
           1) бэкенд не прислал id (явный сигнал «эта статья уже лайкнута»);
           2) у нас есть id, и он лежит в localStorage (мы сами лайкали раньше).
         В обоих случаях стартовое состояние — is-active. */
      var startsActive = !articleId || isArticleLiked(articleId);
      if (startsActive) {
        likeButton.classList.add("is-active");
      }

      /**
       * Применение лайка: класс + счётчик (на кнопке и во всех зеркалах) + persist.
       * Лайк у нас односторонний (поставил — не снять), поэтому функция всегда
       * именно АКТИВИРУЕТ кнопку. Вызывается только после успешного ответа сервера
       * (или сразу, если бэка нет вообще) — чтобы UI и серверное состояние
       * не разъезжались при ошибках сети.
       */
      var applyLike = function applyLike() {
        likeButton.classList.add("is-active");
        bumpLikeCount(likeButton, +1, articleId);
        if (articleId) {
          setArticleLiked(articleId, true);
        }
      };
      likeButton.addEventListener("click", function (evt) {
        evt.preventDefault();

        /* Если кнопка уже активна — пользователь (или бэкенд) считает,
           что лайк уже стоит. Никаких запросов и изменений UI: тихо выходим. */
        if (likeButton.classList.contains("is-active")) {
          return;
        }

        /* Защита от двойных кликов: пока запрос в полёте, новые игнорируем,
           иначе можно поставить лайк дважды и развалить счётчик. */
        if (likeButton.dataset.likeRequestPending === "true") {
          return;
        }
        var url = "?";
        url += "like" + "=" + true;

        /* id добавляем в query только если он есть, чтобы не отправлять "id=null"
           и не путать бэкенд пустыми параметрами. */
        if (articleId) {
          url += "&" + "id" + "=" + encodeURIComponent(articleId);
        }
        if (!action) {
          /* data-url не задан — никуда стучаться нельзя.
             Применяем визуально, чтобы интерфейс хоть как-то реагировал на клик.
             На сервер ничего не уходит, но локальное состояние сохранится в localStorage. */
          applyLike();
          return;
        }
        likeButton.dataset.likeRequestPending = "true";
        /* Класс is-loading — необязательный крючок для CSS-стейта (не критично, если стилей нет). */
        likeButton.classList.add("is-loading");
        sendRequest(action + url, function () {
          applyLike();
          likeButton.classList.remove("is-loading");
          likeButton.dataset.likeRequestPending = "false";
        }, function (errorMessage) {
          DEBUG && console.log("Не удалось обновить лайк:", errorMessage);
          likeButton.classList.remove("is-loading");
          likeButton.dataset.likeRequestPending = "false";
          /* Намеренно НЕ меняем UI: считаем, что серверное состояние
             важнее, чем оптимистичное предположение клиента. */
        });
      });
    });
  };

  module.init = init;
});
"use strict";

itsoftApp.createModule("startLoad", ["pageLoad"], function () {
  var module = this;
  var LibraryLoader = function LibraryLoader(func, library) {
    this.func = func;
    this.library = library;
    this.startLoad();
  };
  LibraryLoader.prototype.initQueue = function () {
    var LIBRARY_LOADER = this;
    if (!LIBRARY_LOADER.library.loaded) {
      return false;
    }
    if (!LIBRARY_LOADER.library.queue.length) {
      return;
    }
    DEBUG && console.log("[module" + LIBRARY_LOADER.library.name + "] initQueue function fired, queue.length: " + LIBRARY_LOADER.library.queue.length);
    while (LIBRARY_LOADER.library.queue.length > 0) {
      // Взять первый элемент массива,
      // и вызвать его. Мы уже знаем, что это функция,
      // поэтому доп. проверка не требуется.
      LIBRARY_LOADER.library.queue.shift()();
    }
  };
  LibraryLoader.prototype.loadScriptStart = function (f) {
    var LIBRARY_LOADER = this;
    itsoftApp.loadScript(LIBRARY_LOADER.library.script, function () {
      DEBUG && console.log("[module" + LIBRARY_LOADER.library.name + "] library loaded, ready to init queue");
      f();
    });
  };
  LibraryLoader.prototype.loadAndInit = function () {
    var LIBRARY_LOADER = this;
    var f = function f() {
      if (!LIBRARY_LOADER.library.loaded && LIBRARY_LOADER.library.cb && typeof LIBRARY_LOADER.library.cb === "function") {
        LIBRARY_LOADER.library.cb();
      }
      LIBRARY_LOADER.library.loaded = true;
      LIBRARY_LOADER.initQueue();
    };
    if (LIBRARY_LOADER.library.hasOwnProperty("style")) {
      itsoftApp.loadStyle(LIBRARY_LOADER.library.style);
    }
    if (LIBRARY_LOADER.library.hasOwnProperty("dependency") && LIBRARY_LOADER.library.dependency) {
      new itsoftApp.modules.startLoad.callback(function () {
        LIBRARY_LOADER.loadScriptStart(f);
      }, itsoftApp.libraries[LIBRARY_LOADER.library.dependency]);
    } else {
      LIBRARY_LOADER.loadScriptStart(f);
    }
  };
  LibraryLoader.prototype.addEvent = function () {
    var LIBRARY_LOADER = this;
    if (typeof this.func !== "function") {
      return;
    }

    // Если библиотека ещё не загружена, то добавляем в очередь
    if (!this.library.loaded) {
      // Если библиотека ещё не начала грузиться, то загружаем её
      // (причём откладываем загрузку библиотеки до полной загрузки самой страницы).
      if (!this.library.started) {
        this.library.started = true;
        DEBUG && console.log("%c--[module" + this.library.name + "] first function added. delegating loadAndInit to pageLoad module (or firing if page already loaded)", "font-style: italic; color: #999");
        itsoftApp.modules.pageLoad.addEvent(function () {
          LIBRARY_LOADER.loadAndInit();
        });
      }
      this.library.queue.push(this.func);
      DEBUG && console.log("[module " + this.library.name + "] function added, count of functions to init now: " + this.library.queue.length);

      // Если библиотека уже загружена, то просто вызываем переданную функцию
    } else {
      this.func();
    }
  };
  LibraryLoader.prototype.startLoad = function () {
    this.addEvent(this.func);
  };

  // Доступ к функциям
  // текущего модуля
  module.callback = LibraryLoader;
});
"use strict";

itsoftApp.createModule("takeAnim", function () {
  var module = this;
  var init = function init(el) {
    var start = function start() {
      var takeButton = el.querySelector(".js-take-button");
      var beforeBlocks = el.querySelectorAll(".js-before-block");
      var afterBlocks = el.querySelectorAll(".js-after-block");
      var activeBacteriaEls = el.querySelectorAll(".js-active-bacteria-item");
      var isMobile = false;
      var mm = gsap.matchMedia();
      mm.add("(max-width: 767px)", function () {
        isMobile = true;
      });
      mm.add("(min-width: 768px)", function () {
        isMobile = false;
      });
      var onTakeButtonClick = function onTakeButtonClick(evt) {
        evt.preventDefault();
        if (beforeBlocks.length > 0 && afterBlocks.length > 0) {
          beforeBlocks.forEach(function (beforeBlock) {
            beforeBlock.classList.remove("js-show");
            beforeBlock.classList.add("js-hide");
          });
          afterBlocks.forEach(function (afterBlock) {
            afterBlock.classList.remove("js-hide");
            afterBlock.classList.add("js-show");
          });
        }
        gsap.set(activeBacteriaEls, {
          yPercent: -200
        });
        gsap.to(activeBacteriaEls, {
          yPercent: isMobile ? -5 : 0,
          stagger: {
            from: "center",
            amount: 0.1,
            ease: "0.68, 0.13, 0.42, 1.01"
          },
          duration: 1.2,
          ease: "0.68, 0.13, 0.42, 1.01"
        });
      };
      takeButton && takeButton.addEventListener("click", onTakeButtonClick);
    };
    new itsoftApp.modules.startLoad.callback(start, itsoftApp.libraries.gsap);
  };
  module.init = init;
});
"use strict";

itsoftApp.createModule("toggleTabs", function () {
  var module = this;
  var Tabs = function Tabs(tabs) {
    this.tabs = tabs;
    this.tabsInitialized = false;
    this.isContainingTabs = this.tabs.hasAttribute("data-tabs-caption"); /* Содержит ли вкладка дочерние табы */
    this.togglers = this.tabs.querySelector(".js-tabs-list.js-toggle"); /* находим на странице возможный тогглер */
    this.noHash = this.tabs.hasAttribute("data-no-hash"); // если стоит этот атрибут, табы будут перкеключаться без изменения хэша
    this.isTogglerProgress = ""; // this.toggler.classList.contains("js-toggle-progress");
    this.togglerProgress = ""; // tabs.querySelector(".js-progress");
    this.tabsItems = []; // все кнопки для переключения вкладок
    this.currentActiveTabs = []; // все активные кнопки для переключения вкладок
    this.currentActiveContents = []; // все активные секции активной вкладки
    this.clickedTab = ""; // кнопка, на которую кликнули в данный момент
    this.clickedTabName = ""; // название кнопки, на которую кликнули
    this.dataActiveSectionClass;
    this.dataActiveSectionSelector;
    this.sectionElement;
    this.toggleFlag = 0;
    this.dataButtons = ""; // Название кнопок табов 
    this.dataSection = ""; // Название секции табов
    this.currentTab = "";
    this.tabSelector = "";
    this.tabsContents = "";

    /* в зависимости от условий */
    this.dataSliderName = ""; /* название слайдера, который требуется листать при переключении табов */
    this.dataLevel = ""; /* вложенная секция с табами */
    this.dataLevelValue = ""; /* название уровня вложенной секции с табами */
    this.dataTabsValue = ""; /* название уровня списка кнопок во вложенной секции с табами** */

    this.init();
  };
  Tabs.prototype.init = function () {
    if (this.tabs.hasAttribute("data-slider-name")) {
      this.sliderName = this.tabs.getAttribute("data-slider-name");
    }
    if (this.isContainingTabs) {
      this.dataLevel = this.tabs.querySelector("[data-level]");
      this.dataTabsValue = this.tabs.getAttribute("data-tabs-caption");
      this.dataButtons = this.tabs.querySelector("[data-tabs-buttons='" + this.dataTabsValue + "']");
      this.dataSection = this.tabs.querySelector("[data-tabs-section='" + this.dataTabsValue + "']");
    }
    if (this.dataLevel) {
      this.dataLevelValue = this.dataLevel.getAttribute("data-level");
    }
    if (!this.isContainingTabs) {
      this.dataButtons = this.tabs.querySelector(".js-tabs-list");
      this.dataSection = this.tabs.querySelector(".js-tabs-content");
    }
    if (this.dataLevel && this.dataLevelValue === this.dataTabsValue) {
      /* если название указано, находим активные секции только внутри блока с названием табов */
      this.currentActiveContents = this.dataSection.querySelectorAll(".js-tab-content--active[data-level='" + this.dataTabsValue + "']");
    } else {
      /* иначе находим все */
      this.currentActiveContents = this.dataSection.querySelectorAll(".js-tab-content--active");
    }
    this.tabsItems = this.dataButtons.querySelectorAll(".js-tab-name");
    this.currentActiveTabs = this.dataButtons.querySelectorAll(".js-tab-name--active");
    for (var i = 0; i < this.tabsItems.length; i++) {
      this.addTabClickListener(this.tabsItems[i]);
    }
    if (!this.tabsInitialized) {
      this.tabsInitialized = true;
      if (location.hash && !this.noHash) {
        this.goToHash(location.hash);
      }
      if (this.isTogglerProgress && this.togglerProgress) {
        var element;
        var contentElements;
        var contentSelector;
        var tabsExample = this;
        var togglerProgress = this.togglerProgress;
        var startAnimation = itsoftApp.modules.animation.callback;
        var options = {
          draw: function draw(progress) {
            togglerProgress.style.transform = "scaleX(" + progress * 100 + "%)";
          },
          timing: function timing(timeFraction) {
            return timeFraction;
          },
          duration: 5000,
          cb: function cb() {
            if (tabsExample.tabsItems[0].classList.contains("js-tab-name--active")) {
              element = tabsExample.tabsItems[1];
              contentSelector = "[data-content-url='" + element.getAttribute("data-tab-name") + "']";
              contentElements = tabsExample.dataSection.querySelectorAll(contentSelector);
              tabsExample.goToTab(element, contentElements);
            } else {
              element = tabsExample.tabsItems[0];
              contentSelector = "[data-content-url='" + element.getAttribute("data-tab-name") + "']";
              contentElements = tabsExample.dataSection.querySelectorAll(contentSelector);
              tabsExample.goToTab(element, contentElements);
            }
            startAnimation(options);
          }
        };
        startAnimation(options);
      }

      /* Этот метод позволяет перейти к любой вкладке по хэшу из другого модуля */
      module.callback.goToHash = this.goToHash;
    }
  };
  Tabs.prototype.goToHash = function (newHash) {
    var element;
    var contentElements;
    var contentSelector;
    if (newHash) {
      newHash = newHash.replace(/^#/, "");
      var selector = "[data-tab-name='" + newHash + "']";
      contentSelector = "[data-content-url='" + newHash + "']";
      element = this.dataButtons.querySelector(selector);
      contentElements = this.dataSection.querySelectorAll(contentSelector);
    } else {
      element = this.tabsItems[0];
      contentSelector = "[data-content-url='" + element.getAttribute("data-tab-name") + "']";
      contentElements = this.dataSection.querySelectorAll(contentSelector);
    }

    // DEBUG && console.log("contentElementsHash", contentElements);

    if (element) {
      this.goToTab(element, contentElements, newHash);
    }
  };
  Tabs.prototype.goToTab = function (tab, contents, newHash) {
    /* Логика переключения к определенному табу */
    this.toggleFlag = 0;
    if (this.tabs.classList.contains("js-init-settings")) {
      this.tabs.classList.remove("js-init-settings");
    }
    this.clickedTab = tab;
    if (!this.clickedTab.classList.contains("js-tab-name--active")) {
      if (this.toggler && !this.toggleFlag && newHash != this.tabsItems[0].getAttribute("data-tab-name")) {
        this.toggler.classList.toggle("js-toggle--active");
        this.toggleFlag = 1;
      }
    }
    Array.prototype.forEach.call(this.currentActiveTabs, function (currentActiveTab) {
      currentActiveTab.classList.remove("js-tab-name--active");
    });
    Array.prototype.forEach.call(this.currentActiveContents, function (currentActiveContent) {
      currentActiveContent.classList.remove("js-tab-content--active");
    });
    if (this.dataActiveSectionClass) {
      this.sectionElement.classList.remove(this.dataActiveSectionClass);
    }
    if (this.dataSliderName) {
      var slideIndex = this.clickedTab.getAttribute("data-slide-to");
      if (itsoftApp.modules.slidersLibrary.sliders[this.sliderName]) {
        itsoftApp.modules.slidersLibrary.sliders[this.sliderName].slideTo(+slideIndex);
      }
    }
    this.clickedTabName = this.clickedTab.getAttribute("data-tab-name");
    if (!this.noHash) {
      location.hash = this.clickedTabName;
    }
    this.currentActiveTabs = this.dataButtons.querySelectorAll("[data-tab-name='" + this.clickedTabName + "']");
    this.dataActiveSectionSelector = tab.getAttribute("data-section-selector");
    if (this.dataActiveSectionSelector) {
      this.sectionElement = this.dataSection.querySelector(this.dataActiveSectionSelector);
    }
    this.dataActiveSectionClass = tab.getAttribute("data-section-class");
    if (this.dataActiveSectionClass) {
      this.sectionElement.classList.add(this.dataActiveSectionClass);
    }
    this.currentActiveContents = contents;
    Array.prototype.forEach.call(this.currentActiveTabs, function (currentActiveTab) {
      currentActiveTab.classList.add("js-tab-name--active");
    });
    Array.prototype.forEach.call(this.currentActiveContents, function (currentActiveContent) {
      var customScroll = currentActiveContent.querySelector(".custom-scroll");
      if (customScroll && !customScroll.classList.contains("js-triggered")) {
        customScroll.classList.add("js-triggered");
        itsoftApp.modules.customScrollbar.callback(customScroll);
      }
      currentActiveContent.classList.add("js-tab-content--active");
    });
    Array.prototype.forEach.call(itsoftApp.modules.scrollEffects.scrollEffectElements, function (scrollEffectElement) {
      scrollEffectElement._check();
    });
  };
  Tabs.prototype.onTabClick = function (currentTab) {
    this.currentTab = currentTab;
    if (this.currentTab.hasAttribute("data-tab-name")) {
      this.tabSelector = this.currentTab.getAttribute("data-tab-name");
      if (!this.noHash) {
        location.hash = this.tabSelector;
      }
    }
    this.tabsContents = this.dataSection.querySelectorAll("[data-content-url='" + this.tabSelector + "']");
    // DEBUG && console.log("dataSection", dataSection);
    // DEBUG && console.log("contentElements", tabsContents);
    // После обработки клика передаём элемент, на который произошёл клик, и элемент (вкладка), который должен быть показан универсальной функции goToTab
    if (!this.currentTab.closest(".js-disabled-tabs")) {
      this.goToTab(this.currentTab, this.tabsContents);
    }
  };
  Tabs.prototype.addTabClickListener = function (tab) {
    /* Добавляем обработчик события клика */
    tab.addEventListener("click", function (evt) {
      evt.preventDefault();
      if (!evt.currentTarget.classList.contains("js-tab-name--active")) {
        this.onTabClick(tab);
      } else if (this.tabs.classList.contains("js-init-settings")) {
        this.tabs.classList.remove("js-init-settings");
      }
    }.bind(this));
  };
  module.callback = {};
  module.callback.init = Tabs;
});
"use strict";

itsoftApp.createModule("uteka", function () {
  var module = this;
  var initUteka = function initUteka() {
    window.uteka.onReady(function () {
      var widget = document.querySelector('.uteka-widget');
      window.uteka.loadWidget(widget, {
        productId: widget.getAttribute("data-id") || null,
        productIds: []
      });
    });
  };
  module.callback = initUteka;
});
// itsoftApp.createModule("utekaInit", function () {
//     var module = this;

//     window.isLoadedUtekasProducts = false;

//     var utekaInit = function () {
//         window.uteka = {            
//             _host: 'widget.uteka.ru',
//             _queue: [],
//             _loaded: false,
//             loadWidgetPre: function (widget, options) {
//                 if (
//                     !options.productId &&
//                     !options.productIds
//                 ) {
//                     throw new TypeError("Для загрузки виджета необходимо передать параметр 'productId' или 'productIds'");
//                 }

//                 if (
//                     options.productId &&
//                     options.productIds &&
//                     options.productIds.length > 0 &&
//                     options.productIds.indexOf(options.productId) === -1
//                 ) {
//                     throw new TypeError("Параметр 'productIds' должен в себя включать ID товара, переданный через параметр 'productId'");
//                 }

//                 var query = [];

//                 if (options.productIds) {
//                     options.productIds.forEach(function (productId) {
//                         query.push("productIds=" + productId);
//                     });
//                 }
//                 if (options.productId) {
//                     query.push("productId=" + options.productId);
//                 }
//                 if (options.utmTerm) {
//                     query.push("utm_term=" + options.utmTerm);
//                 }
//                 if (options.utmSource) {
//                     query.push("utm_source=" + options.utmSource);
//                 }
//                 if (options.utmMedium) {
//                     query.push("utm_medium=" + options.utmMedium);
//                 }
//                 if (options.utmContent) {
//                     query.push("utm_content=" + options.utmContent);
//                 }
//                 if (options.utmCampaign) {
//                     query.push("utm_campaign=" + options.utmCampaign);
//                 }

//                 var src = 'https://' + window.uteka._host + '/static/widgets/widget.compiled.js?l=' + Date.now()
//                 // src.defer = true;
//                 itsoftApp.loadScript(src, function () {
//                     window.uteka.loadWidget(widget, options)
//                 });
//             },
//         };
//     };

//     module.callback = utekaInit;
// });
"use strict";
"use strict";

itsoftApp.createModule("videoAutoplay", function () {
  var module = this;
  var firstAutoplay = document.querySelector(".js-first-autoplay");
  var videoInit = function videoInit(video) {
    var onVideoPlay = function onVideoPlay() {
      video.removeEventListener('canplaythrough', onVideoPlay);
      DEBUG && console.log('Видео готово к воспроизведению. Можно запускать!');
      video.play()["catch"](function (error) {
        console.log("Автозапуск все еще заблокирован:", error);
      });
    };
    if (video) {
      video.muted = true; // Обязательно выключаем звук
      video.playsInline = true;
      if (!video.classList.contains("js-no-loop")) {
        video.autoplay = true;
        video.loop = true;
      }

      // if (video.classList.contains("js-nodownload")) {
      //     video.setAttribute("controlslist", "nodownload");
      // }

      // document.addEventListener('touchstart', () => {
      //     video.play();
      // }, { once: true });

      onVideoPlay();
      if (video.readyState >= 4) {
        onVideoPlay();
        DEBUG && console.log("Видео уже можно запускать");
      } else {
        video.addEventListener('canplaythrough');
      }

      // video.addEventListener('canplaythrough', onVideoPlay);
    }
  };

  if (firstAutoplay) {
    itsoftApp.modules.pageLoad.addEvent(function () {
      // setTimeout(function () {
      videoInit(firstAutoplay);
      // }, 300);
    });
  }

  module.init = videoInit;
});
"use strict";

itsoftApp.createModule("videoPopup", ["popups"], function () {
  var module = this;
  var videoEls = document.querySelectorAll("video");
  if (videoEls.length > 0) {
    videoEls.forEach(function (videoEl) {
      videoEl.setAttribute("controlslist", "nodownload");
    });
  }
  var VideoPopup = function VideoPopup(triggerButton, popup) {
    this.triggerButton = triggerButton;
    this.popup = popup;
    this.video = popup.querySelector("video");
    this.init();
  };
  VideoPopup.prototype.init = function () {
    var VIDEO_POPUP = this;
    var popup = VIDEO_POPUP.popup;
    var video = VIDEO_POPUP.video;
    this.onPopupOpenListener = this.onPopupOpen.bind(VIDEO_POPUP);
    this.onPopupCloseListener = this.onPopupClose.bind(VIDEO_POPUP);
    // this.onVideoPlayListener = this.onVideoPlay.bind(VIDEO_POPUP);

    popup && popup.addEventListener("popups:open", this.onPopupOpenListener);
    popup && popup.addEventListener("popups:close", this.onPopupCloseListener);

    // popup.dispatchEvent(window.openEvent);
    // video.addEventListener("click", onVideoPlayListener);
  };

  VideoPopup.prototype.onPopupOpen = function (evt) {
    var VIDEO_POPUP = this;
    VIDEO_POPUP.video.play();
    VIDEO_POPUP.video.classList.add("js-active");
  };
  VideoPopup.prototype.onPopupClose = function (evt) {
    var VIDEO_POPUP = this;
    VIDEO_POPUP.video.pause();
    VIDEO_POPUP.video.classList.remove("js-active");
  };
  var videoPopupInit = function videoPopupInit(triggerButton) {
    var popup = document.querySelector("#" + triggerButton.getAttribute("data-popup-id"));
    new VideoPopup(triggerButton, popup);
  };
  module.init = videoPopupInit;
});
"use strict";

/**
 * Общая точка входа
 * для события изменения размеров экрана.
 *
 * NOTE: Событие на практике происходит редко
 * (например, поворот планшета или телефона, или равзернуть окно на полный экран на десктопе),
 * поэтому мы будем "выполнять" его с помощью debouncer
 * (отложенное выполнение).
 */
itsoftApp.createModule("windowResize", function () {
  // Локальные переменные
  var module = this;
  var events = [];
  var $window = itsoftApp.commonVars.$window;

  /**
   * Основной обработчик,
   * который проходит по всем функциям из массива events
   * и выполняет их.
   *
   * Вызываем обработчик через debouncer (задержка по выполнению),
   * чтобы функции из массива не вызывались слишком часто.
   */
  var resizeController = itsoftApp.utils.debouncer(function () {
    if (!events.length) {
      return;
    }
    var f, i, len;
    if (itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.viewWidth) {
      itsoftApp.utils.getViewportSize();
    }
    if (itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.viewHeight) {
      itsoftApp.utils.getViewportHeight();
    }
    if (itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.headerHeight) {
      itsoftApp.utils.getHeaderHeight();
      itsoftApp.utils.getHeaderFixedHeight();
      itsoftApp.utils.getHeaderStaticHeight();
    }
    if (itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight) {
      itsoftApp.utils.getDisclaimerHeight();
    }
    if (itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.cookieHeight) {
      itsoftApp.utils.getCookieHeight();
    }
    for (i = 0, len = events.length; i < len; i++) {
      f = events[i];
      f();
    }
  });

  /**
   * Добавление переданной функции в массив всех функций,
   * которые будут вызваны при срабатывании события "resize" окна браузера.
   *
   * @param {function} func
   */
  var addEvent = function addEvent(func, name) {
    if (typeof func !== "function") {
      return;
    }
    var method = function method(action) {
      if (action) {
        var index = events.indexOf(method);
        if (index !== -1) {
          events.splice(index, 1);
          DEBUG && console.log("".concat(name, " \u0443\u0434\u0430\u043B\u0451\u043D"));
        }
      } else {
        func();
      }
    };
    events.push(method);
    DEBUG && console.log("[module windowResize] function added, count of functions to init now: " + events.length);
    return method;
  };

  // Привязка события и обработчика
  $window.addEventListener("resize", resizeController);

  // Доступ к фукциям
  // текущего модуля
  module.addEvent = addEvent;
});
"use strict";

/**
 * Общая точка входа
 * для события скролла страницы.
 *
 * NOTE: Контроллер будет передавать текущее значение скролла
 * каждой из переданных в данный модуль функций.
 */
itsoftApp.createModule("windowScroll", function () {
  // Локальные переменные
  var module = this;
  var events = [];
  var enabled = false;
  var $window = itsoftApp.commonVars.$window;

  /**
   * Основной обработчик,
   * который проходит по всем функциям из массива events
   * и выполняет их.
   */
  var scrollController = function scrollController() {
    if (!enabled) {
      return;
    }
    var y = document.body.scrollTop || document.documentElement.scrollTop;
    var f, i, len;
    for (i = 0, len = events.length; i < len; i++) {
      f = events[i];
      f.call(this, y);
    }
  };

  /**
   * Привязка события и контроллера.
   * Вынесено в отдельную функцию, так как если модулю не передана ни одна функция на событие "scroll"
   * то и общий обработчик вешать нет смысла.
   * Сделано для оптимизации производительности (небольшая прибавка).
   */
  var bind = function bind() {
    $window.addEventListener("scroll", scrollController);
  };

  /**
   * Добавление переданной функции в массив всех функций,
   * которые будут вызваны при срабатывании события "scroll".
   *
   * @param {function} func
   */
  var addEvent = function addEvent(func) {
    if (typeof func !== "function") {
      return;
    }
    if (!enabled) {
      enabled = true;
      bind();
    }
    events.push(func);
    DEBUG && console.log("[module windowScroll] function added, count of functions to init now: " + events.length);
  };

  // Доступ к фукциям
  // текущего модуля
  module.addEvent = addEvent;
});